var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g, _path47, _path48, _g2, _path49, _path50, _g3, _path51, _path52, _g4, _path53, _path54, _path55, _g5, _path56, _path57, _path58, _path59, _path60, _g6, _path61, _path62, _g7, _path63, _path64, _g8, _path65, _path66, _g9, _path67, _path68, _path69, _ellipse3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaticImage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 121,
    viewBox: "0 0 112 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.1686,
    cy: 74.0191,
    rx: 47.1686,
    ry: 46.9808,
    fill: "url(#paint0_linear_607_7366)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9843,
    cy: 106.759,
    rx: 6.64347,
    ry: 6.61702,
    fill: "#3C37FF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M41.1258 77.0016C20.0628 77.0016 3 76.0514 3 74.8959C3 73.7403 20.0628 72.8195 41.1258 72.8253C62.1889 72.8312 79.2516 73.7755 79.2516 74.931C79.2516 76.0865 62.1889 77.0133 41.1258 77.0016Z",
    fill: "url(#paint1_radial_607_7366)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.372 43.2808L54.0589 57.5809L64.7459 71.881H43.372H21.9922L32.685 57.5809L43.372 43.2808Z",
    fill: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M54.0648 57.575L43.3719 43.2632L32.7084 57.575L22.0215 71.8752H64.7752L54.0648 57.575ZM22.9776 71.4528L33.1777 57.575L43.3778 43.9319L53.5779 57.575L63.7956 71.4528H22.9717H22.9776Z",
    fill: "url(#paint2_radial_607_7366)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7082 71.881H19.001V75.2302H67.7082V71.881Z",
    fill: "#2B2B2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.0068 71.8751V75.2302H67.6906V71.8751H19.0068ZM67.0278 74.6847H19.6872V72.4206H67.0278V74.6847Z",
    fill: "url(#paint3_linear_607_7366)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_607_7366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 43,
    width: 44,
    height: 29
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.372 43.2748L54.0648 57.5749L64.7518 71.875H43.372H21.998L32.685 57.5749L43.372 43.2748Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_607_7366)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M42.9906 67.6637C27.8517 67.6637 15.5752 63.857 15.5693 59.1998C15.5635 54.5426 27.8341 50.771 42.9789 50.7886C58.1236 50.8062 70.3943 54.5895 70.4001 59.2526C70.406 63.9157 58.1295 67.6754 42.9906 67.6637Z",
    fill: "url(#paint4_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M42.9914 69.3295C28.9845 69.3295 17.623 64.1972 17.623 57.9035C17.623 51.6098 28.9728 46.5303 42.9796 46.5479C56.9865 46.5655 68.348 51.6802 68.348 57.968C68.348 64.2559 56.9982 69.3471 42.9914 69.3295Z",
    fill: "url(#paint5_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45,
    d: "M64.1834 76.2156C35.4131 76.2156 12.086 74.2448 12.0742 71.8458C12.0625 69.4468 35.3779 67.5111 64.1482 67.5229C92.9185 67.5346 116.252 69.4996 116.263 71.8986C116.275 74.2976 92.9537 76.2332 64.1834 76.2156Z",
    fill: "url(#paint6_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45,
    d: "M22.0159 76.2273C-12.139 76.2273 -39.8418 74.2565 -39.8477 71.8516C-39.8535 69.4467 -12.18 67.5229 21.9807 67.5346C56.1414 67.5463 83.8325 69.5113 83.8442 71.9103C83.8559 74.3093 56.1707 76.2449 22.0159 76.2273Z",
    fill: "url(#paint7_radial_607_7366)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2261 4.06405C53.062 4.86333 56.6982 6.42513 59.9189 8.65674C63.0257 10.811 65.6866 13.5456 67.7552 16.7101C69.8283 19.8666 71.2723 23.3938 72.0077 27.0979C72.7622 30.9429 72.7362 34.9003 71.9315 38.7351C71.1345 42.5715 69.5769 46.2094 67.3505 49.4337C65.193 52.5378 62.4589 55.1981 59.2972 57.2701C56.1362 59.3404 52.605 60.7804 48.8976 61.5108C45.0533 62.2701 41.0953 62.2461 37.2605 61.4404C33.4228 60.6442 29.7845 59.0843 26.5618 56.8536C23.4556 54.7011 20.7947 51.9685 18.7255 48.8062C16.6552 45.6424 15.2135 42.1096 14.4788 38.4007C13.7244 34.5557 13.7503 30.5983 14.5551 26.7636C15.3503 22.9274 16.9103 19.2908 19.1419 16.0708C21.2925 12.9629 24.0255 10.3017 27.1894 8.23442C30.3471 6.15178 33.8788 4.70162 37.5889 3.96433C41.4352 3.21476 45.3932 3.24868 49.2261 4.06405Z",
    fill: "#FFF6E3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4745 32.4237L19.0418 16.2056C16.8949 19.3499 15.3808 22.8821 14.584 26.6051L42.4745 32.4237Z",
    fill: "#F71C28"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9148 31.9545L37.4012 4.02295C33.8073 4.7482 30.3813 6.14088 27.3008 8.12881L42.9148 31.9545Z",
    fill: "#F71C28"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5654 31.9896L59.7836 8.55689C56.6419 6.40523 53.1087 4.89073 49.384 4.09912L43.5654 31.9896Z",
    fill: "#F71C28"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2852 57.2709H59.2921V57.264L59.2852 57.2709Z",
    fill: "#E70507"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5596 33.5439L49.0497 61.4755C52.6442 60.7525 56.0706 59.3597 59.1501 57.3696L43.5596 33.5439Z",
    fill: "#F71C28"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33.0748L67.4327 49.293C69.5854 46.1519 71.1 42.6184 71.8905 38.8934L44 33.0748Z",
    fill: "#F71C28"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0352 32.4236L71.9667 26.9394C71.2423 23.3453 69.8495 19.9192 67.8608 16.839L44.0352 32.4236Z",
    fill: "#F71C28"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9086 33.5148L26.6904 56.9768C29.8352 59.1228 33.3673 60.6368 37.09 61.4346L42.9086 33.5148Z",
    fill: "#F71C28"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4452 33.0748L14.5254 38.5708C15.2536 42.1638 16.646 45.5892 18.6312 48.6712L42.4452 33.0748Z",
    fill: "#F71C28"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78,
    d: "M44.2823 62.8796C60.4317 62.2536 73.0004 48.2555 72.3553 31.6141C71.7102 14.9727 58.0955 1.98967 41.9461 2.61572C25.7968 3.24176 13.228 17.2398 13.8732 33.8812C14.5183 50.5226 28.1329 63.5056 44.2823 62.8796Z",
    fill: "url(#paint8_radial_607_7366)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9668 33.9429C76.1302 29.5667 75.4121 25.2023 73.8553 21.1092C72.3497 17.1632 70.0973 13.5446 67.2214 10.4515C64.3469 7.35703 60.9012 4.84745 57.074 3.061C53.1093 1.21018 48.8125 0.176863 44.4397 0.0226658C40.0641 -0.140186 35.7002 0.575826 31.606 2.12838C27.6582 3.63303 24.0391 5.88778 20.9484 8.76814C17.8539 11.6417 15.3426 15.0851 13.552 18.9096C11.7068 22.8721 10.6737 27.164 10.5136 31.5322C10.3479 35.908 11.064 40.2725 12.6193 44.3659C14.1241 48.3123 16.3766 51.9311 19.2532 55.0235C22.1273 58.1185 25.5731 60.6282 29.4006 62.4141C33.3689 64.2663 37.6699 65.2996 42.0466 65.4524C46.4205 65.6182 50.7831 64.902 54.8745 63.3467C58.825 61.8549 62.4513 59.6166 65.5556 56.7539C68.6474 53.877 71.1566 50.4319 72.9461 46.6066C74.7939 42.6313 75.8213 38.3242 75.9668 33.9429ZM68.8696 44.6827C67.3256 47.9851 65.1587 50.9586 62.4879 53.4399C59.8183 55.921 56.6957 57.8647 53.2908 59.1646C49.7603 60.5049 45.9962 61.1213 42.2226 60.977C38.4474 60.8448 34.7373 59.9552 31.3127 58.361C28.0102 56.817 25.0368 54.6502 22.5555 51.9793C20.0724 49.3112 18.1285 46.1882 16.8308 42.7822C15.4906 39.2515 14.8723 35.4879 15.0125 31.714C15.1467 27.9385 16.0383 24.2284 17.6343 20.8042C19.1782 17.5031 21.3429 14.53 24.0102 12.047C26.6783 9.56091 29.8011 7.61314 33.2073 6.31049C36.74 4.97033 40.5056 4.35204 44.2814 4.49218C48.0569 4.62641 51.767 5.51802 55.1912 7.11406C58.4937 8.65804 61.4671 10.8249 63.9484 13.4957C66.4277 16.1669 68.3675 19.2918 69.6614 22.6987C71.0072 26.23 71.6257 29.9967 71.4797 33.7728C71.3493 37.5476 70.4617 41.2576 68.8696 44.6827Z",
    fill: "url(#paint9_linear_607_7366)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3397 26.2531C74.4821 21.9589 72.7643 17.8826 70.2895 14.2699C67.904 10.7891 64.8687 7.80162 61.3504 5.47164C57.8315 3.13414 53.8939 1.49894 49.7543 0.656048C45.4638 -0.218032 41.0411 -0.218032 36.7505 0.656048C32.4559 1.51524 28.3784 3.23082 24.7614 5.70039C21.2812 8.089 18.2939 11.126 15.9632 14.6453C13.6173 18.166 11.9759 22.1079 11.13 26.2531C10.2588 30.544 10.2588 34.9661 11.13 39.257C11.9939 43.5511 13.7112 47.628 16.1802 51.2461C18.5658 54.7288 21.6034 57.7166 25.1251 60.0443C28.6434 62.3829 32.5812 64.0182 36.7212 64.8599C41.0117 65.7342 45.4345 65.7342 49.725 64.8599C54.0177 63.9971 58.0929 62.2797 61.7083 59.8097C65.1906 57.4236 68.1783 54.3861 70.5065 50.8648C72.8424 47.3451 74.4775 43.4078 75.3221 39.2687C76.2036 34.9756 76.2096 30.5487 75.3397 26.2531ZM75.0816 39.1573C74.248 43.2445 72.6328 47.1322 70.3247 50.6067C68.0208 54.0856 65.0649 57.0853 61.6203 59.4402C58.0505 61.8779 54.0273 63.5734 49.7895 64.4259C45.5508 65.2854 41.1828 65.2854 36.9441 64.4259C32.8585 63.5966 28.9711 61.9874 25.4946 59.6865C22.0188 57.3809 19.0213 54.4252 16.667 50.9821C14.2286 47.4106 12.5331 43.3854 11.6813 39.1455C10.8189 34.9091 10.8189 30.5424 11.6813 26.3059C12.516 22.2191 14.1312 18.3316 16.4383 14.8565C18.7432 11.3804 21.6966 8.38118 25.1368 6.023C28.709 3.58596 32.734 1.89059 36.9734 1.03732C41.2121 0.177824 45.5802 0.177824 49.8189 1.03732C53.907 1.86777 57.7953 3.48323 61.2683 5.79424C64.7432 8.10867 67.7386 11.0722 70.0901 14.5221C72.5285 18.0936 74.224 22.1189 75.0758 26.3587C75.9345 30.5815 75.9365 34.9337 75.0816 39.1573Z",
    fill: "url(#paint10_linear_607_7366)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1684 48.6301C69.2158 45.5444 70.6497 42.0932 71.3916 38.4652C72.1571 34.7009 72.1571 30.821 71.3916 27.0567C70.633 23.2932 69.1293 19.7195 66.969 16.5458C64.8702 13.4873 62.1992 10.8641 59.1034 8.82087C56.0163 6.77201 52.5629 5.33807 48.9326 4.59769C45.1703 3.83202 41.2923 3.83202 37.53 4.59769C33.7647 5.35347 30.19 6.85955 27.019 9.02617C23.9686 11.1211 21.3499 13.7836 19.3059 16.8683C17.2585 19.9562 15.8247 23.4093 15.0827 27.0391C14.3201 30.8017 14.3201 34.6791 15.0827 38.4417C15.8385 42.2071 17.3446 45.7817 19.5112 48.9527C21.6031 52.0089 24.266 54.6319 27.3534 56.6776C30.4365 58.7296 33.8887 60.1639 37.5183 60.9007C41.2826 61.6664 45.1624 61.6664 48.9267 60.9007C52.6899 60.1437 56.2624 58.6377 59.4318 56.4723C62.4907 54.3797 65.1175 51.717 67.1684 48.6301ZM48.7683 60.1089C45.1123 60.851 41.3444 60.851 37.6884 60.1089C34.1613 59.386 30.806 57.9921 27.805 56.003C24.8019 54.0144 22.2124 51.4628 20.1799 48.4893C18.0732 45.4092 16.6089 41.9361 15.8746 38.2775C15.1324 34.6194 15.1324 30.8497 15.8746 27.1916C16.5933 23.6633 17.9875 20.3073 19.9804 17.3083C21.9706 14.3064 24.5219 11.7173 27.4941 9.6831C30.5755 7.5788 34.0481 6.11476 37.706 5.37782C41.364 4.63571 45.1338 4.63571 48.7918 5.37782C52.3183 6.0966 55.6724 7.49083 58.6693 9.48367C61.6719 11.4705 64.2613 14.0201 66.2945 16.9915C68.3994 20.0741 69.8616 23.5491 70.5939 27.2092C71.3389 30.865 71.3389 34.6334 70.5939 38.2892C69.8763 41.8178 68.482 45.1741 66.488 48.1726C64.5015 51.1754 61.9519 53.7649 58.9802 55.7977C55.9002 57.9058 52.4272 59.372 48.7683 60.1089Z",
    fill: "url(#paint11_linear_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M43.2666 39.6617C39.1607 39.6617 35.8174 36.5471 35.8174 32.7345C35.8174 28.922 39.1549 25.8308 43.2666 25.8426C47.3783 25.8543 50.7158 28.9513 50.7158 32.7697C50.7158 36.5882 47.3724 39.6676 43.2666 39.6617Z",
    fill: "url(#paint12_radial_607_7366)"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1815 31.7491C48.3194 32.4107 48.3194 33.0936 48.1815 33.7552C48.0509 34.3839 47.8 34.9814 47.4425 35.5148C47.0832 36.0587 46.6209 36.527 46.0817 36.8932C45.5257 37.273 44.8996 37.5382 44.2399 37.6733C43.5778 37.8053 42.8961 37.8053 42.2339 37.6733C41.6056 37.5382 41.0086 37.2854 40.4743 36.9284C39.9318 36.5697 39.4638 36.1096 39.0959 35.5735C38.716 35.0153 38.4509 34.3873 38.3158 33.7258C38.1838 33.0656 38.1838 32.3859 38.3158 31.7257C38.4455 31.0866 38.6985 30.479 39.0607 29.9367C39.415 29.41 39.867 28.956 40.3921 28.5994C40.9488 28.2181 41.5776 27.9546 42.2398 27.8251C42.8994 27.6872 43.5803 27.6872 44.2399 27.8251C44.8684 27.9564 45.4658 28.2073 45.9996 28.5642C46.5423 28.9249 47.0103 29.387 47.378 29.925C47.7665 30.4724 48.0398 31.093 48.1815 31.7491Z",
    fill: "url(#paint13_linear_607_7366)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6945 30.8049C41.9559 30.6004 42.2548 30.4489 42.5744 30.3591C42.8832 30.2725 43.2059 30.2466 43.5246 30.2829C43.8408 30.3222 44.147 30.4196 44.4279 30.5703C44.7209 30.7298 44.9783 30.9474 45.1845 31.2096C45.3877 31.4697 45.5391 31.7664 45.6303 32.0836C45.7166 32.3925 45.7425 32.7151 45.7065 33.0338C45.668 33.3528 45.5684 33.6615 45.4133 33.9429C45.256 34.2341 45.0403 34.4897 44.7798 34.6937C44.5201 34.9022 44.2207 35.0558 43.9 35.1454C43.5922 35.227 43.272 35.2509 42.9556 35.2158C42.6369 35.1792 42.3283 35.0816 42.0465 34.9283C41.7566 34.7692 41.5013 34.5538 41.2957 34.2949C41.0872 34.0351 40.9336 33.7358 40.844 33.415C40.7622 33.1053 40.7383 32.7832 40.7736 32.4648C40.8111 32.1463 40.9086 31.8378 41.0611 31.5557C41.2202 31.2658 41.4356 31.0105 41.6945 30.8049Z",
    fill: "url(#paint14_linear_607_7366)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0784 31.5321C40.9161 31.8218 40.8125 32.1407 40.7734 32.4706C40.7352 32.8012 40.7631 33.1362 40.8556 33.456C40.9462 33.7633 41.0956 34.0502 41.2955 34.3006C41.4934 34.5511 41.7385 34.7603 42.0169 34.9165C42.3067 35.0788 42.6256 35.1825 42.9554 35.2215C43.2841 35.2597 43.6172 35.2318 43.935 35.1394C44.2424 35.0489 44.5292 34.8995 44.7796 34.6994C45.0334 34.5034 45.2449 34.258 45.4013 33.978C45.5637 33.6882 45.6673 33.3693 45.7063 33.0395C45.7427 32.7104 45.7128 32.3773 45.6184 32.06C45.53 31.7529 45.3825 31.466 45.1843 31.2153C44.9855 30.9642 44.7406 30.7531 44.4629 30.5936C44.1731 30.4313 43.8542 30.3276 43.5244 30.2886C43.1937 30.2534 42.8593 30.2812 42.539 30.3707C42.2326 30.4637 41.9462 30.6129 41.6943 30.8106C41.4452 31.0099 41.2361 31.2547 41.0784 31.5321ZM41.8116 30.9455C42.0426 30.7607 42.3077 30.6232 42.5918 30.5408C42.8869 30.4561 43.1958 30.4302 43.5009 30.4646C43.8064 30.4983 44.1018 30.5942 44.369 30.7461C44.6288 30.8951 44.8561 31.0945 45.0377 31.3327C45.2225 31.5636 45.36 31.8287 45.4424 32.1128C45.527 32.4079 45.553 32.7168 45.5186 33.0219C45.4839 33.3254 45.3881 33.6187 45.2371 33.8842C45.0897 34.145 44.89 34.3727 44.6505 34.5528C44.4211 34.7399 44.1555 34.8777 43.8704 34.9575C43.5762 35.047 43.2668 35.075 42.9613 35.0397C42.6564 34.9993 42.3619 34.9018 42.0932 34.7522C41.8363 34.6016 41.6111 34.4024 41.4304 34.1657C41.2455 33.9339 41.1061 33.6692 41.0198 33.3856C40.9351 33.0904 40.9092 32.7815 40.9435 32.4764C40.9797 32.1714 41.0753 31.8765 41.2251 31.6083C41.3768 31.3522 41.5758 31.1272 41.8116 30.9455Z",
    fill: "url(#paint15_linear_607_7366)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M38.8503 30.2711C38.5175 30.856 38.3079 31.5027 38.2344 32.1715C38.1548 32.8406 38.2106 33.5188 38.3986 34.1658C38.5861 34.7892 38.8884 35.3721 39.2902 35.8844C39.6935 36.3934 40.1914 36.8196 40.7566 37.1396C41.3435 37.4724 41.9922 37.6819 42.6628 37.7555C43.3319 37.8346 44.01 37.7788 44.6571 37.5913C45.2792 37.405 45.8604 37.1025 46.3699 36.6997C46.8789 36.2964 47.3051 35.7985 47.6251 35.2333C47.9571 34.6456 48.1684 33.9975 48.2468 33.327C48.3215 32.6576 48.2638 31.9799 48.0767 31.3328C47.8951 30.7099 47.5943 30.1283 47.191 29.62C46.7842 29.1122 46.2846 28.6862 45.7188 28.3648C45.1331 28.0328 44.487 27.8214 43.8184 27.7431C43.149 27.6624 42.4701 27.7203 41.8241 27.9132C41.2 28.0961 40.6166 28.3967 40.1055 28.7989C39.5963 29.2043 39.1701 29.7042 38.8503 30.2711ZM40.3401 29.098C40.8124 28.7249 41.352 28.4461 41.9297 28.2768C42.527 28.1025 43.1531 28.0486 43.7714 28.1185C44.3912 28.195 44.9894 28.3944 45.5311 28.705C46.0539 29.0054 46.5139 29.4037 46.886 29.8781C47.2585 30.3486 47.5373 30.8863 47.7072 31.4618C47.8813 32.0612 47.9351 32.6891 47.8656 33.3094C47.7891 33.9292 47.5897 34.5274 47.279 35.0691C46.9793 35.594 46.5809 36.0561 46.1059 36.4299C45.6336 36.803 45.094 37.0818 44.5164 37.2511C43.9206 37.4234 43.296 37.4733 42.6804 37.3977C42.06 37.3245 41.4611 37.1249 40.9208 36.8112C40.3975 36.5092 39.9358 36.1112 39.56 35.6381C39.1869 35.1658 38.9081 34.6261 38.7388 34.0485C38.5637 33.4492 38.5118 32.8207 38.5863 32.2009C38.6595 31.5804 38.8591 30.9815 39.1729 30.4412C39.471 29.9237 39.8652 29.4678 40.3342 29.098H40.3401Z",
    fill: "url(#paint16_linear_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M73.662 35.2157C73.0466 35.1662 72.4755 34.8762 72.0726 34.4084C71.6696 33.9407 71.4673 33.333 71.5094 32.717C71.4871 32.0986 71.7101 31.4964 72.1297 31.0416C72.5494 30.5867 73.1318 30.3161 73.75 30.2887C74.3643 30.3382 74.9345 30.6274 75.3373 31.0939C75.7401 31.5604 75.9432 32.1666 75.9027 32.7815C75.9265 33.401 75.7042 34.0047 75.2844 34.4608C74.8646 34.9169 74.2813 35.1883 73.662 35.2157Z",
    fill: "url(#paint17_radial_607_7366)"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8498 33.8784C73.5498 33.871 73.264 33.7489 73.0513 33.5373C72.8385 33.3256 72.715 33.0405 72.7061 32.7405C72.7134 32.4405 72.8355 32.1547 73.0472 31.9419C73.2588 31.7292 73.544 31.6056 73.844 31.5967C73.9939 31.5959 74.1425 31.6248 74.2812 31.6816C74.42 31.7385 74.5461 31.8222 74.6524 31.9279C74.7587 32.0336 74.843 32.1593 74.9006 32.2978C74.9581 32.4362 74.9877 32.5847 74.9877 32.7346C74.9804 33.0346 74.8583 33.3204 74.6466 33.5332C74.435 33.7459 74.1498 33.8695 73.8498 33.8784Z",
    fill: "url(#paint18_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M74.4303 34.283C74.2391 34.2696 74.0524 34.2186 73.881 34.1329C73.7096 34.0471 73.5568 33.9283 73.4314 33.7834C73.3061 33.6384 73.2106 33.47 73.1505 33.288C73.0904 33.106 73.0669 32.9139 73.0812 32.7228C73.0653 32.3357 73.2032 31.9581 73.4648 31.6724C73.7263 31.3867 74.0903 31.216 74.4772 31.1978C74.6687 31.2119 74.8555 31.2636 75.027 31.35C75.1984 31.4363 75.3512 31.5556 75.4765 31.7011C75.6018 31.8466 75.6972 32.0153 75.7572 32.1977C75.8172 32.38 75.8407 32.5724 75.8263 32.7639C75.8407 33.1499 75.7021 33.526 75.4407 33.8105C75.1793 34.0949 74.8162 34.2647 74.4303 34.283Z",
    fill: "url(#paint19_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M45.3553 32.6056C45.3671 32.8752 45.3256 33.1446 45.2332 33.3982C45.1408 33.6518 44.9993 33.8847 44.8168 34.0835C44.6342 34.2824 44.4143 34.4433 44.1696 34.5571C43.9248 34.6708 43.66 34.7352 43.3903 34.7465C43.1214 34.7724 42.8501 34.7449 42.5918 34.6657C42.3335 34.5864 42.0934 34.457 41.8853 34.2848C41.6771 34.1127 41.505 33.9011 41.3788 33.6622C41.2525 33.4234 41.1747 33.162 41.1497 32.893C41.1371 32.6236 41.1778 32.3544 41.2696 32.1009C41.3613 31.8473 41.5023 31.6144 41.6843 31.4154C41.8664 31.2165 42.0859 31.0555 42.3304 30.9416C42.5748 30.8278 42.8394 30.7634 43.1088 30.7521C43.6522 30.7014 44.1935 30.8679 44.6145 31.2152C45.0355 31.5626 45.3018 32.0624 45.3553 32.6056Z",
    fill: "url(#paint20_radial_607_7366)"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3813 32.7463C44.3713 33.0404 44.2512 33.32 44.0448 33.5297C43.8384 33.7394 43.5607 33.8638 43.2668 33.8784C42.965 33.8784 42.6756 33.7585 42.4622 33.5451C42.2488 33.3317 42.1289 33.0423 42.1289 32.7405C42.1363 32.4404 42.2583 32.1547 42.47 31.9419C42.6817 31.7291 42.9668 31.6056 43.2668 31.5967C43.5637 31.6115 43.8438 31.7384 44.0507 31.9518C44.2575 32.1652 44.3757 32.4492 44.3813 32.7463Z",
    fill: "url(#paint21_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M44.9272 32.5469C44.9508 32.7654 44.9309 32.9864 44.8686 33.1972C44.8063 33.4079 44.703 33.6043 44.5645 33.775C44.426 33.9456 44.2551 34.0872 44.0617 34.1915C43.8683 34.2958 43.6561 34.3608 43.4374 34.3827C43.2198 34.4125 42.9984 34.3991 42.786 34.3432C42.5736 34.2874 42.3743 34.1902 42.1994 34.0573C42.0246 33.9244 41.8776 33.7583 41.767 33.5686C41.6563 33.3789 41.5841 33.1692 41.5546 32.9516C41.531 32.7335 41.5507 32.5129 41.6126 32.3025C41.6745 32.0921 41.7773 31.896 41.9152 31.7254C42.0531 31.5548 42.2233 31.4131 42.4161 31.3085C42.6089 31.2039 42.8204 31.1383 43.0385 31.1157C43.4787 31.0555 43.9247 31.1724 44.2788 31.4407C44.6329 31.709 44.8661 32.1068 44.9272 32.5469Z",
    fill: "url(#paint22_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M66.7642 13.2141C66.2897 13.6086 65.6789 13.8002 65.0641 13.7475C64.4493 13.6948 63.88 13.402 63.4796 12.9326C63.0316 12.5058 62.7705 11.9193 62.7529 11.3008C62.7353 10.6823 62.9628 10.0819 63.3857 9.63033C63.8602 9.23589 64.471 9.04426 65.0858 9.09696C65.7006 9.14965 66.2699 9.44244 66.6704 9.91188C67.1183 10.3387 67.3795 10.9252 67.397 11.5437C67.4146 12.1622 67.1872 12.7625 66.7642 13.2141Z",
    fill: "url(#paint23_radial_607_7366)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0014 12.0998C65.8957 12.206 65.77 12.2903 65.6316 12.3478C65.4932 12.4054 65.3448 12.435 65.1949 12.435C65.045 12.435 64.8966 12.4054 64.7582 12.3478C64.6198 12.2903 64.4941 12.206 64.3884 12.0998C64.2823 11.9946 64.1982 11.8694 64.1407 11.7315C64.0833 11.5935 64.0537 11.4456 64.0537 11.2962C64.0537 11.1468 64.0833 10.9989 64.1407 10.861C64.1982 10.7231 64.2823 10.5979 64.3884 10.4927C64.4941 10.3864 64.6198 10.3021 64.7582 10.2446C64.8966 10.1871 65.045 10.1575 65.1949 10.1575C65.3448 10.1575 65.4932 10.1871 65.6316 10.2446C65.77 10.3021 65.8957 10.3864 66.0014 10.4927C66.2142 10.706 66.3336 10.9949 66.3336 11.2962C66.3336 11.5975 66.2142 11.8865 66.0014 12.0998Z",
    fill: "url(#paint24_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M66.4296 12.1758C66.1337 12.4238 65.7516 12.5446 65.3668 12.5116C64.9821 12.4786 64.6261 12.2946 64.3767 11.9999C64.0953 11.7329 63.9308 11.3656 63.9187 10.9779C63.9066 10.5902 64.048 10.2134 64.3122 9.92936C64.6098 9.68171 64.9934 9.56183 65.3791 9.5959C65.7648 9.62996 66.1213 9.8152 66.371 10.1112C66.6511 10.378 66.8145 10.7447 66.8255 11.1314C66.8365 11.5182 66.6942 11.8936 66.4296 12.1758Z",
    fill: "url(#paint25_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M56.9806 59.9212C56.4938 58.9006 55.1036 58.5428 53.8719 59.1294C52.6401 59.7159 52.0418 61.0181 52.5287 62.0621C53.0155 63.1062 54.4056 63.4405 55.6374 62.854C56.8692 62.2674 57.4674 60.9477 56.9806 59.9212Z",
    fill: "url(#paint26_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M45.6126 2.36299C45.6126 3.5009 44.5216 4.4218 43.1608 4.42766C41.8 4.43353 40.6914 3.52437 40.6856 2.38646C40.6797 1.24855 41.7766 0.327671 43.1373 0.321805C44.4981 0.31594 45.6126 1.23095 45.6126 2.36299Z",
    fill: "url(#paint27_radial_607_7366)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1203 3.34247C43.7488 3.34247 44.2582 2.83301 44.2582 2.20456C44.2582 1.57611 43.7488 1.06665 43.1203 1.06665C42.4919 1.06665 41.9824 1.57611 41.9824 2.20456C41.9824 2.83301 42.4919 3.34247 43.1203 3.34247Z",
    fill: "url(#paint28_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M44.6683 1.77637C44.6471 2.16287 44.4733 2.52515 44.1851 2.78361C43.897 3.04207 43.518 3.17556 43.1315 3.15477C42.7453 3.17728 42.3659 3.04629 42.0758 2.7903C41.7858 2.53432 41.6087 2.17411 41.583 1.78811C41.6042 1.40161 41.778 1.03933 42.0661 0.780873C42.3543 0.522417 42.7332 0.388924 43.1198 0.409714C43.506 0.3872 43.8854 0.518197 44.1754 0.774179C44.4655 1.03016 44.6426 1.39038 44.6683 1.77637Z",
    fill: "url(#paint29_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M23.3242 9.68305C24.1278 10.4866 23.9929 11.9119 23.0309 12.8739C22.069 13.8358 20.6319 13.959 19.8342 13.1613C19.0365 12.3636 19.1656 10.9265 20.1275 9.9646C21.0895 9.00266 22.5089 8.87948 23.3242 9.68305Z",
    fill: "url(#paint30_radial_607_7366)"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6203 12.1232C20.7256 12.2292 20.8508 12.3134 20.9887 12.3709C21.1266 12.4283 21.2745 12.4579 21.4239 12.4579C21.5733 12.4579 21.7212 12.4283 21.8592 12.3709C21.9971 12.3134 22.1223 12.2292 22.2275 12.1232C22.3337 12.0175 22.418 11.8918 22.4755 11.7534C22.5331 11.615 22.5627 11.4666 22.5627 11.3167C22.5627 11.1668 22.5331 11.0184 22.4755 10.88C22.418 10.7416 22.3337 10.6159 22.2275 10.5102C22.0096 10.3039 21.721 10.189 21.421 10.189C21.121 10.189 20.8323 10.3039 20.6145 10.5102C20.5086 10.6163 20.4248 10.7423 20.3678 10.8809C20.3108 11.0195 20.2817 11.168 20.2822 11.3179C20.2828 11.4678 20.3129 11.6161 20.3709 11.7543C20.429 11.8925 20.5137 12.0179 20.6203 12.1232Z",
    fill: "url(#paint31_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M22.2389 9.9118C22.4951 10.2014 22.6259 10.5807 22.6029 10.9667C22.5798 11.3526 22.4046 11.7136 22.1158 11.9706C21.8561 12.2581 21.4933 12.4313 21.1064 12.4521C20.7196 12.473 20.3402 12.34 20.0511 12.082C19.795 11.7924 19.6641 11.4131 19.6872 11.0272C19.7103 10.6413 19.8854 10.2802 20.1743 10.0232C20.4339 9.73569 20.7968 9.56257 21.1836 9.54168C21.5705 9.5208 21.9499 9.65387 22.2389 9.9118Z",
    fill: "url(#paint32_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M12.9248 29.7725C14.0568 29.7725 14.9543 30.9456 14.9191 32.2829C14.8839 33.6202 13.9395 34.7229 12.8075 34.6995C11.6754 34.676 10.7839 33.5264 10.8132 32.189C10.8425 30.8517 11.7927 29.7725 12.9248 29.7725Z",
    fill: "url(#paint33_radial_607_7366)"
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7662 33.3797C13.0703 33.3799 13.3627 33.262 13.5815 33.0508C13.8004 32.8396 13.9287 32.5516 13.9393 32.2477C13.9394 31.9426 13.8207 31.6494 13.6082 31.4304C13.3958 31.2114 13.1064 31.0837 12.8014 31.0746C12.5014 31.082 12.2156 31.204 12.0028 31.4157C11.7901 31.6274 11.6665 31.9125 11.6576 32.2125C11.6537 32.3619 11.6793 32.5107 11.7329 32.6502C11.7865 32.7898 11.8671 32.9174 11.9701 33.0258C12.073 33.1342 12.1963 33.2213 12.3329 33.282C12.4695 33.3427 12.6168 33.3759 12.7662 33.3797Z",
    fill: "url(#paint34_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M12.4432 30.6816C12.8283 30.7145 13.1848 30.8982 13.4352 31.1925C13.6856 31.4869 13.8097 31.8682 13.7805 32.2536C13.7916 32.6412 13.6494 33.0175 13.3847 33.3008C13.1201 33.5841 12.7543 33.7516 12.3669 33.7669C11.9818 33.734 11.6253 33.5504 11.3749 33.256C11.1245 32.9617 11.0004 32.5803 11.0296 32.195C11.0169 31.807 11.1586 31.4298 11.4236 31.1461C11.6886 30.8625 12.0552 30.6954 12.4432 30.6816Z",
    fill: "url(#paint35_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M14.2967 42.0901C15.3642 41.7147 16.5959 42.4478 17.0476 43.7324C17.4992 45.0169 17.0007 46.366 15.9273 46.7414C14.8539 47.1168 13.628 46.3836 13.1764 45.0991C12.7247 43.8145 13.2291 42.4713 14.2967 42.0901Z",
    fill: "url(#paint36_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M14.4255 42.4655C14.9147 42.3444 15.4318 42.4212 15.8645 42.6793C16.2973 42.9375 16.6107 43.3559 16.7366 43.8438C16.9427 44.3041 16.9599 44.827 16.7843 45.2998C16.6088 45.7726 16.2547 46.1576 15.7981 46.3719C15.3083 46.4912 14.7911 46.4128 14.3586 46.1538C13.9262 45.8947 13.6131 45.4758 13.4871 44.9876C13.2812 44.5282 13.2642 44.0062 13.4397 43.5343C13.6153 43.0625 13.9694 42.6786 14.4255 42.4655Z",
    fill: "url(#paint37_radial_607_7366)"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5987 45.451C15.8668 45.3157 16.0728 45.0827 16.1743 44.8001C16.2758 44.5175 16.265 44.2067 16.1442 43.9318C16.0089 43.6637 15.776 43.4577 15.4934 43.3563C15.2108 43.2548 14.9 43.2655 14.6251 43.3863C14.357 43.5216 14.151 43.7545 14.0495 44.0372C13.948 44.3198 13.9588 44.6306 14.0795 44.9055C14.2148 45.1736 14.4478 45.3796 14.7304 45.481C15.013 45.5825 15.3238 45.5718 15.5987 45.451Z",
    fill: "url(#paint38_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M14.039 43.1576C14.4108 43.0507 14.8098 43.0956 15.1485 43.2826C15.4872 43.4695 15.7379 43.7832 15.8456 44.1548C15.9937 44.5127 15.9941 44.9147 15.8469 45.2729C15.6996 45.6312 15.4166 45.9166 15.0596 46.0669C14.6878 46.1739 14.2888 46.1289 13.9501 45.942C13.6114 45.755 13.3607 45.4414 13.253 45.0698C13.1049 44.7119 13.1044 44.3099 13.2517 43.9516C13.399 43.5934 13.682 43.3079 14.039 43.1576Z",
    fill: "url(#paint39_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M19.5578 51.8738C20.4083 51.123 21.8278 51.34 22.7311 52.3548C23.6344 53.3695 23.6754 54.8124 22.8249 55.5691C21.9744 56.3257 20.5609 56.1028 19.6576 55.0822C18.7543 54.0616 18.7132 52.6481 19.5578 51.8738Z",
    fill: "url(#paint40_radial_607_7366)"
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0039 54.5191C22.1099 54.4139 22.1941 54.2887 22.2515 54.1508C22.309 54.0129 22.3385 53.8649 22.3385 53.7155C22.3385 53.5661 22.309 53.4182 22.2515 53.2803C22.1941 53.1424 22.1099 53.0172 22.0039 52.912C21.8981 52.8057 21.7724 52.7214 21.634 52.6639C21.4956 52.6064 21.3472 52.5768 21.1974 52.5768C21.0475 52.5768 20.8991 52.6064 20.7607 52.6639C20.6223 52.7214 20.4966 52.8057 20.3908 52.912C20.2846 53.0177 20.2003 53.1434 20.1428 53.2818C20.0853 53.4202 20.0557 53.5686 20.0557 53.7185C20.0557 53.8684 20.0853 54.0168 20.1428 54.1552C20.2003 54.2936 20.2846 54.4192 20.3908 54.525C20.4966 54.6315 20.6224 54.716 20.7611 54.7734C20.8998 54.8309 21.0485 54.8602 21.1986 54.8597C21.3487 54.8591 21.4972 54.8288 21.6354 54.7703C21.7737 54.7118 21.8989 54.6264 22.0039 54.5191Z",
    fill: "url(#paint41_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M19.7224 52.9588C20.027 52.7197 20.4138 52.6108 20.7984 52.6558C21.183 52.7009 21.5342 52.8963 21.7753 53.1993C22.0479 53.4749 22.2008 53.8469 22.2008 54.2345C22.2008 54.6222 22.0479 54.9942 21.7753 55.2698C21.47 55.5083 21.0827 55.6162 20.698 55.57C20.3134 55.5239 19.9626 55.3274 19.7224 55.0235C19.4516 54.7481 19.2998 54.3774 19.2998 53.9911C19.2998 53.6049 19.4516 53.2342 19.7224 52.9588Z",
    fill: "url(#paint42_radial_607_7366)"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8248 61.54C53.7702 61.4003 53.7439 61.2512 53.7474 61.1012C53.7509 60.9513 53.7842 60.8035 53.8453 60.6665C53.9064 60.5295 53.9942 60.4061 54.1034 60.3033C54.2127 60.2005 54.3413 60.1205 54.4817 60.0678C54.6211 60.0139 54.7698 59.9879 54.9193 59.9914C55.0687 59.9949 55.216 60.0279 55.3528 60.0883C55.4895 60.1488 55.6129 60.2356 55.7161 60.3438C55.8193 60.452 55.9001 60.5794 55.954 60.7189C56.0078 60.8587 56.0335 61.0077 56.0296 61.1574C56.0257 61.3071 55.9922 61.4546 55.9312 61.5914C55.8702 61.7282 55.7827 61.8516 55.6739 61.9545C55.5651 62.0574 55.437 62.1378 55.297 62.1911C55.1576 62.2451 55.009 62.2711 54.8595 62.2675C54.71 62.264 54.5627 62.2311 54.426 62.1707C54.2893 62.1102 54.1658 62.0234 54.0627 61.9152C53.9595 61.807 53.8787 61.6795 53.8248 61.54Z",
    fill: "url(#paint43_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M72.0542 42.5417C71.4677 42.3559 70.8316 42.4079 70.283 42.6866C69.7345 42.9652 69.3173 43.4482 69.1215 44.0315C68.8653 44.5936 68.8411 45.234 69.0541 45.8138C69.2671 46.3936 69.7002 46.866 70.2594 47.1285C70.846 47.3143 71.482 47.2623 72.0306 46.9837C72.5792 46.705 72.9963 46.222 73.1922 45.6387C73.4484 45.0766 73.4726 44.4362 73.2595 43.8564C73.0465 43.2766 72.6134 42.8042 72.0542 42.5417Z",
    fill: "url(#paint44_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M72.1542 42.8701C72.6154 43.0736 72.978 43.4504 73.1635 43.9191C73.349 44.3878 73.3425 44.9107 73.1455 45.3747C73.0232 45.8664 72.712 46.2899 72.2793 46.5535C71.8466 46.8171 71.3274 46.8993 70.8345 46.7824C70.3743 46.5778 70.0127 46.2008 69.8274 45.7326C69.6421 45.2643 69.6477 44.742 69.8432 44.2778C70.2479 43.2103 71.2509 42.571 72.1542 42.8701Z",
    fill: "url(#paint45_radial_607_7366)"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0225 45.8675C70.7544 45.7322 70.5484 45.4992 70.4469 45.2166C70.3455 44.934 70.3562 44.6232 70.477 44.3483C70.6123 44.0802 70.8452 43.8742 71.1279 43.7728C71.4105 43.6713 71.7213 43.682 71.9962 43.8028C72.1316 43.8669 72.2529 43.9571 72.3534 44.0682C72.4538 44.1794 72.5313 44.3092 72.5814 44.4504C72.6316 44.5915 72.6533 44.7411 72.6455 44.8907C72.6377 45.0403 72.6004 45.1869 72.5358 45.322C72.4728 45.4577 72.3836 45.5795 72.2732 45.6805C72.1629 45.7815 72.0336 45.8596 71.8929 45.9103C71.7522 45.961 71.6028 45.9833 71.4534 45.976C71.304 45.9686 71.1576 45.9318 71.0225 45.8675Z",
    fill: "url(#paint46_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M72.3012 43.5447C71.9332 43.4243 71.5326 43.4549 71.1872 43.6298C70.8419 43.8047 70.5801 44.1095 70.4594 44.4773C70.2979 44.8289 70.2826 45.2302 70.4168 45.5931C70.551 45.956 70.8236 46.2509 71.175 46.4129C71.5421 46.5335 71.9421 46.5037 72.2873 46.33C72.6325 46.1563 72.8948 45.8529 73.0167 45.4862C73.1784 45.1337 73.1939 44.7315 73.0598 44.3677C72.9257 44.0038 72.6529 43.7079 72.3012 43.5447Z",
    fill: "url(#paint47_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M66.6409 52.648C66.2015 52.2128 65.6081 51.9686 64.9897 51.9686C64.3713 51.9686 63.7779 52.2128 63.3386 52.648C62.8533 53.0316 62.5391 53.5913 62.4644 54.2053C62.3897 54.8193 62.5606 55.4381 62.9397 55.9268C63.3788 56.3602 63.971 56.6032 64.588 56.6032C65.2049 56.6032 65.7971 56.3602 66.2362 55.9268C66.7223 55.5441 67.0376 54.9848 67.1134 54.3707C67.1892 53.7566 67.0194 53.1374 66.6409 52.648Z",
    fill: "url(#paint48_radial_607_7366)"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9775 55.3403C63.7712 55.1224 63.6562 54.8338 63.6562 54.5338C63.6562 54.2338 63.7712 53.9451 63.9775 53.7273C64.0832 53.621 64.2089 53.5367 64.3473 53.4792C64.4857 53.4217 64.6341 53.3921 64.784 53.3921C64.9339 53.3921 65.0823 53.4217 65.2207 53.4792C65.3591 53.5367 65.4847 53.621 65.5905 53.7273C65.7967 53.9451 65.9117 54.2338 65.9117 54.5338C65.9117 54.8338 65.7967 55.1224 65.5905 55.3403C65.3726 55.5465 65.084 55.6615 64.784 55.6615C64.484 55.6615 64.1953 55.5465 63.9775 55.3403Z",
    fill: "url(#paint49_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M66.2128 53.604C65.939 53.3304 65.5677 53.1766 65.1805 53.1766C64.7934 53.1766 64.4221 53.3304 64.1482 53.604C63.8447 53.8443 63.648 54.1945 63.6008 54.5787C63.5536 54.9629 63.6597 55.3503 63.896 55.6569C64.1706 55.9292 64.5416 56.0819 64.9283 56.0819C65.315 56.0819 65.686 55.9292 65.9606 55.6569C66.2641 55.4166 66.4608 55.0664 66.508 54.6822C66.5552 54.298 66.4491 53.9106 66.2128 53.604Z",
    fill: "url(#paint50_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M56.4701 60.8245C56.2852 60.4851 55.9734 60.2328 55.6029 60.1228C55.2324 60.0129 54.8335 60.0543 54.4934 60.2379C54.1347 60.3849 53.8487 60.668 53.6982 61.0252C53.5476 61.3825 53.5446 61.7848 53.6898 62.1442C53.7813 62.3131 53.9053 62.4622 54.0545 62.583C54.2037 62.7039 54.3753 62.7942 54.5594 62.8487C54.7436 62.9032 54.9367 62.9208 55.1276 62.9005C55.3186 62.8803 55.5037 62.8226 55.6724 62.7308C55.85 62.6581 56.0115 62.5511 56.1477 62.4159C56.284 62.2807 56.3922 62.12 56.4663 61.943C56.5404 61.7659 56.5788 61.576 56.5795 61.3841C56.5801 61.1922 56.543 61.002 56.4701 60.8245Z",
    fill: "url(#paint51_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M28.9551 59.3406C29.4713 58.3317 30.8731 58.0091 32.0814 58.6309C33.2897 59.2526 33.8411 60.5724 33.3484 61.5636C32.8557 62.5549 31.4304 62.8951 30.2162 62.2733C29.0021 61.6516 28.439 60.3494 28.9551 59.3406Z",
    fill: "url(#paint52_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M29.1897 59.6455C29.4316 59.203 29.8386 58.8739 30.322 58.73C30.8053 58.5861 31.326 58.639 31.7706 58.8772C32.2476 59.0394 32.6423 59.3817 32.8703 59.8311C33.0983 60.2805 33.1415 60.8012 32.9906 61.282C32.8688 61.5052 32.7038 61.702 32.5052 61.8609C32.3066 62.0198 32.0784 62.1376 31.8339 62.2075C31.5893 62.2773 31.3334 62.2978 31.0808 62.2679C30.8283 62.2379 30.5842 62.158 30.3628 62.0328C29.8966 61.8637 29.514 61.5207 29.2952 61.0756C29.0765 60.6305 29.0387 60.1179 29.1897 59.6455Z",
    fill: "url(#paint53_radial_607_7366)"
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0168 61.0767C32.1162 60.7938 32.1034 60.4836 31.9813 60.2098C31.8591 59.936 31.6367 59.7194 31.3599 59.6044C31.2201 59.5506 31.071 59.5249 30.9213 59.5288C30.7716 59.5327 30.6241 59.5661 30.4873 59.6272C30.3505 59.6882 30.2272 59.7756 30.1242 59.8845C30.0213 59.9933 29.9409 60.1214 29.8876 60.2613C29.7882 60.5442 29.8009 60.8544 29.9231 61.1282C30.0453 61.402 30.2676 61.6186 30.5445 61.7336C30.8274 61.833 31.1376 61.8203 31.4114 61.6981C31.6852 61.5759 31.9018 61.3535 32.0168 61.0767Z",
    fill: "url(#paint54_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M29.3539 60.2732C29.5508 59.9397 29.8716 59.6976 30.2464 59.5998C30.6211 59.502 31.0193 59.5564 31.3541 59.7511C31.707 59.9104 31.9834 60.2017 32.1238 60.5626C32.2642 60.9235 32.2574 61.325 32.1049 61.6809C31.9069 62.0132 31.5861 62.2543 31.2118 62.352C30.8375 62.4497 30.4398 62.3961 30.1047 62.2029C29.7518 62.0437 29.4754 61.7524 29.335 61.3915C29.1946 61.0306 29.2014 60.6291 29.3539 60.2732Z",
    fill: "url(#paint55_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M33.4833 3.96413C33.929 5.00819 33.2721 6.31033 32.0169 6.82063C30.7617 7.33093 29.3891 6.93208 28.9434 5.88802C28.4976 4.84396 29.1545 3.57115 30.4097 3.03739C31.6649 2.50363 33.0375 2.89661 33.4833 3.96413Z",
    fill: "url(#paint56_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M33.1305 4.12849C33.2736 4.6115 33.2209 5.1314 32.9838 5.57589C32.7467 6.02038 32.3443 6.35376 31.8635 6.50401C31.4129 6.72975 30.8918 6.77024 30.4117 6.61678C29.9316 6.46333 29.5306 6.12812 29.2944 5.68285C29.1529 5.19985 29.2063 4.68064 29.4431 4.23655C29.68 3.79247 30.0814 3.45888 30.5614 3.30732C31.623 2.87914 32.7727 3.2428 33.1305 4.12849Z",
    fill: "url(#paint57_radial_607_7366)"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9818 5.09622C30.0879 5.37763 30.2979 5.60758 30.5686 5.73856C30.8394 5.86955 31.15 5.89157 31.4365 5.80009C31.7168 5.69292 31.9454 5.4824 32.0753 5.21182C32.2051 4.94123 32.2263 4.63117 32.1345 4.34543C32.0858 4.20407 32.0095 4.07376 31.9102 3.96203C31.8108 3.8503 31.6903 3.75937 31.5556 3.69448C31.4209 3.62958 31.2746 3.592 31.1253 3.58393C30.976 3.57585 30.8266 3.59744 30.6857 3.64744C30.5443 3.69623 30.4139 3.77243 30.3019 3.87169C30.19 3.97094 30.0987 4.09131 30.0333 4.22588C29.968 4.36044 29.9298 4.50656 29.9209 4.65591C29.9121 4.80526 29.9328 4.95488 29.9818 5.09622Z",
    fill: "url(#paint58_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M32.4035 3.75312C32.4687 3.93333 32.4977 4.12463 32.4887 4.31606C32.4797 4.50749 32.433 4.69526 32.3513 4.86859C32.2695 5.04191 32.1543 5.19738 32.0123 5.32604C31.8703 5.45471 31.7042 5.55405 31.5237 5.61835C31.3516 5.70372 31.1643 5.75429 30.9727 5.76717C30.781 5.78006 30.5886 5.75499 30.4066 5.69342C30.2247 5.63185 30.0566 5.535 29.9121 5.40838C29.7676 5.28176 29.6496 5.12787 29.5646 4.95555C29.4346 4.5915 29.4541 4.19074 29.6191 3.8411C29.784 3.49147 30.0808 3.22148 30.4445 3.09032C30.7926 2.92108 31.1933 2.89574 31.56 3.01979C31.9266 3.14384 32.2297 3.40729 32.4035 3.75312Z",
    fill: "url(#paint59_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M15.9979 19.0679C17.0361 19.5254 17.4291 20.9097 16.8719 22.1531C16.3147 23.3966 15.0301 24.0301 13.9919 23.5726C12.9537 23.1151 12.5666 21.7308 13.118 20.4873C13.6693 19.2439 14.9597 18.628 15.9979 19.0679Z",
    fill: "url(#paint60_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M15.699 19.549C16.1419 19.789 16.4726 20.1936 16.6196 20.6754C16.7667 21.1572 16.7183 21.6775 16.4849 22.124C16.3287 22.6036 15.9903 23.0027 15.5427 23.2352C15.0951 23.4678 14.5741 23.5153 14.0918 23.3674C13.212 22.9979 12.8659 21.8424 13.3058 20.7925C13.4634 20.3138 13.8019 19.9157 14.2491 19.6833C14.6963 19.4509 15.2167 19.4027 15.699 19.549Z",
    fill: "url(#paint61_radial_607_7366)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6078 22.3879C14.7484 22.4393 14.8977 22.4625 15.0472 22.4561C15.1968 22.4497 15.3436 22.4139 15.4792 22.3507C15.6149 22.2875 15.7368 22.1982 15.8379 22.0878C15.9389 21.9774 16.0173 21.8482 16.0683 21.7075C16.1625 21.4225 16.1439 21.1122 16.0162 20.8405C15.8886 20.5688 15.6616 20.3564 15.3821 20.247C15.2415 20.1956 15.0922 20.1724 14.9427 20.1788C14.7931 20.1852 14.6463 20.221 14.5107 20.2842C14.375 20.3474 14.2531 20.4367 14.152 20.5471C14.051 20.6575 13.9726 20.7867 13.9216 20.9274C13.8274 21.2124 13.846 21.5227 13.9737 21.7944C14.1013 22.0661 14.3283 22.2785 14.6078 22.3879Z",
    fill: "url(#paint62_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M15.112 19.6662C15.4555 19.8439 15.7144 20.1506 15.832 20.519C15.9497 20.8873 15.9165 21.2873 15.7397 21.6312C15.6719 21.8107 15.5695 21.9751 15.4382 22.115C15.3069 22.2549 15.1493 22.3675 14.9745 22.4465C14.7996 22.5255 14.6109 22.5692 14.4191 22.5753C14.2274 22.5813 14.0363 22.5495 13.8568 22.4817C13.6857 22.3949 13.5335 22.2749 13.4091 22.1288C13.2847 21.9826 13.1905 21.8132 13.1322 21.6304C13.0738 21.4476 13.0523 21.255 13.0689 21.0638C13.0856 20.8727 13.1401 20.6867 13.2292 20.5167C13.297 20.3372 13.3994 20.1728 13.5307 20.0329C13.662 19.893 13.8196 19.7804 13.9944 19.7014C14.1693 19.6224 14.358 19.5787 14.5497 19.5726C14.7415 19.5666 14.9326 19.5984 15.112 19.6662Z",
    fill: "url(#paint63_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M72.5237 23.7486C71.9394 23.9353 71.3053 23.8857 70.7571 23.6105C70.2089 23.3354 69.7903 22.8564 69.5909 22.2764C69.3302 21.7145 69.3024 21.0723 69.5133 20.4899C69.7243 19.9076 70.157 19.4323 70.7171 19.1677C71.3014 18.981 71.9355 19.0306 72.4837 19.3058C73.0318 19.581 73.4504 20.0599 73.6498 20.6399C73.9105 21.2018 73.9384 21.844 73.7274 22.4264C73.5164 23.0087 73.0837 23.4841 72.5237 23.7486Z",
    fill: "url(#paint64_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M70.9817 19.3904C71.4645 19.2605 71.979 19.323 72.4166 19.5648C72.8543 19.8066 73.181 20.2088 73.3279 20.6867C73.5494 21.1395 73.5843 21.661 73.4253 22.1392C73.2662 22.6175 72.9259 23.0142 72.4774 23.2441C71.5917 23.596 70.5359 23.0153 70.1312 21.9478C69.9098 21.4951 69.8748 20.9736 70.0339 20.4953C70.1929 20.0171 70.5332 19.6204 70.9817 19.3904Z",
    fill: "url(#paint65_radial_607_7366)"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2834 22.3879C71.9984 22.4842 71.6873 22.4672 71.4144 22.3406C71.1414 22.214 70.9276 21.9873 70.8171 21.7075C70.7229 21.4225 70.7415 21.1122 70.8692 20.8405C70.9968 20.5688 71.2238 20.3564 71.5033 20.247C71.6439 20.1956 71.7932 20.1724 71.9428 20.1788C72.0923 20.1852 72.2391 20.221 72.3748 20.2842C72.5104 20.3474 72.6323 20.4367 72.7334 20.5471C72.8345 20.6575 72.9128 20.7867 72.9638 20.9274C73.0584 21.2117 73.0406 21.5214 72.914 21.7929C72.7875 22.0645 72.5619 22.2774 72.2834 22.3879Z",
    fill: "url(#paint66_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M72.7645 22.7339C72.3966 22.8547 71.9958 22.825 71.6496 22.6514C71.3035 22.4778 71.04 22.1743 70.9169 21.8071C70.7544 21.4561 70.7372 21.0551 70.869 20.6915C71.0009 20.3278 71.271 20.031 71.6207 19.8656C71.9879 19.7446 72.388 19.7734 72.734 19.9459C73.0801 20.1183 73.344 20.4204 73.4683 20.7865C73.631 21.1384 73.6484 21.5403 73.5166 21.9048C73.3848 22.2694 73.1146 22.5673 72.7645 22.7339Z",
    fill: "url(#paint67_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M57.3442 5.36017C56.9453 6.42182 55.5845 6.89107 54.3117 6.4101C53.0389 5.92913 52.3292 4.65043 52.7339 3.61224C53.1386 2.57404 54.4935 2.08134 55.7605 2.56231C57.0274 3.04328 57.7196 4.29851 57.3442 5.36017Z",
    fill: "url(#paint68_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M53.144 3.71195C53.5487 2.84972 54.716 2.53886 55.7483 3.03742C56.2207 3.21432 56.6045 3.57022 56.8163 4.02803C57.0282 4.48584 57.0512 5.00869 56.8803 5.48333C56.4756 6.34556 55.3084 6.65643 54.276 6.15786C53.8046 5.9797 53.4219 5.62366 53.2102 5.16627C52.9985 4.70887 52.9747 4.18668 53.144 3.71195Z",
    fill: "url(#paint69_radial_607_7366)"
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0891 4.86157C55.9831 5.14165 55.774 5.37058 55.5046 5.50145C55.2352 5.63232 54.926 5.65521 54.6403 5.56544C54.3589 5.45941 54.129 5.24934 53.998 4.97864C53.867 4.70794 53.845 4.39726 53.9365 4.11079C53.9858 3.96921 54.0627 3.83878 54.1626 3.72699C54.2625 3.61521 54.3835 3.52427 54.5187 3.45941C54.6539 3.39454 54.8005 3.35703 54.9503 3.34903C55.1 3.34103 55.2498 3.36271 55.3911 3.41279C55.5325 3.46152 55.6628 3.53775 55.7745 3.63712C55.8862 3.73648 55.9772 3.857 56.0421 3.9917C56.107 4.1264 56.1445 4.27263 56.1526 4.42193C56.1607 4.57123 56.1391 4.72066 56.0891 4.86157Z",
    fill: "url(#paint70_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M56.7573 4.50389C56.5983 4.85686 56.3063 5.13262 55.9447 5.27107C55.5832 5.40952 55.1816 5.39941 54.8276 5.24293C54.4582 5.12692 54.15 4.869 53.9707 4.52584C53.7914 4.18268 53.7557 3.78236 53.8715 3.4129C54.0305 3.05993 54.3226 2.78415 54.6841 2.6457C55.0456 2.50725 55.4472 2.51736 55.8012 2.67384C56.1697 2.79118 56.4769 3.04932 56.656 3.39206C56.835 3.73481 56.8715 4.13442 56.7573 4.50389Z",
    fill: "url(#paint71_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_607_7366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 43,
    width: 49,
    height: 33
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7519 71.875L54.065 57.5749L43.3722 43.2748L32.6852 57.5749L21.9982 71.875H19.0068V75.2301H67.7082V71.875H64.7519Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_607_7366)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.62,
    d: "M75.7261 72.2154C75.7261 72.8782 61.1855 73.3885 43.2429 73.324C25.3004 73.2595 10.7539 72.6964 10.7539 72.0395C10.7539 71.3825 25.2945 70.8663 43.2371 70.9309C61.1797 70.9954 75.7203 71.5585 75.7261 72.2154Z",
    fill: "url(#paint72_radial_607_7366)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_607_7366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 66,
    height: 66
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2449 26.3118C74.3837 22.0168 72.6661 17.9394 70.1947 14.3227C67.8075 10.8413 64.7702 7.85378 61.2498 5.52439C57.733 3.18693 53.7974 1.55171 49.6596 0.708815C45.3668 -0.162379 40.9427 -0.162379 36.6499 0.708815C32.3605 1.56304 28.2859 3.26829 24.6667 5.72382C21.187 8.11311 18.1999 11.15 15.8684 14.6687C13.5325 18.1885 11.8974 22.1258 11.0528 26.2648C10.1816 30.5557 10.1816 34.9778 11.0528 39.2687C11.9141 43.5636 13.6317 47.6411 16.103 51.2578C18.4899 54.7375 21.5249 57.7247 25.0421 60.056C28.561 62.3935 32.4986 64.0287 36.6382 64.8716C40.9307 65.7459 45.3554 65.7459 49.6479 64.8716C53.9399 64.0067 58.0147 62.2894 61.6311 59.8214C65.1108 57.4321 68.0979 54.3952 70.4294 50.8765C72.7653 47.3568 74.4004 43.4195 75.2449 39.2804C76.1114 35.0009 76.1114 30.5912 75.2449 26.3118Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_607_7366)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.84,
    d: "M42.708 58.2495C44.3796 57.7744 46.4795 60.0092 47.4004 63.1941C48.3212 66.3791 47.7112 69.3705 46.0396 69.8456C44.3679 70.3207 42.2681 68.086 41.3472 64.9069C40.4263 61.7278 41.0363 58.7246 42.708 58.2495Z",
    fill: "url(#paint73_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.84,
    d: "M40.4679 70.1095C38.7845 69.6755 38.0747 66.7075 38.89 63.4756C39.7053 60.2437 41.7231 57.9738 43.4065 58.402C45.0899 58.8301 45.7937 61.804 44.9843 65.0359C44.1749 68.2677 42.1454 70.5377 40.4679 70.1095Z",
    fill: "url(#paint74_radial_607_7366)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0791 57.5516C43.0928 57.5202 43.1153 57.4935 43.144 57.4747C43.1726 57.4559 43.2061 57.4459 43.2404 57.4459C43.2746 57.4459 43.3081 57.4559 43.3368 57.4747C43.3654 57.4935 43.388 57.5202 43.4017 57.5516L46.0353 63.2881C47.2788 65.9921 45.7244 68.3441 43.2375 68.3441C40.7505 68.3441 39.1961 65.9979 40.4396 63.2881L43.0791 57.5516Z",
    fill: "url(#paint75_linear_607_7366)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M46.0353 63.288L43.3958 57.5456C43.3814 57.5159 43.3589 57.4908 43.3309 57.4733C43.3029 57.4557 43.2705 57.4464 43.2375 57.4464C43.2044 57.4464 43.172 57.4557 43.144 57.4733C43.116 57.4908 43.0935 57.5159 43.0791 57.5456L40.4396 63.288C39.1961 65.992 40.7505 68.3441 43.2375 68.3441C45.7244 68.3441 47.2788 65.992 46.0353 63.288ZM43.2375 67.8045C41.1552 67.8045 39.8531 65.7574 40.8913 63.4053L43.0967 58.4196C43.1069 58.3913 43.1257 58.3669 43.1504 58.3496C43.175 58.3323 43.2044 58.323 43.2345 58.323C43.2646 58.323 43.294 58.3323 43.3187 58.3496C43.3434 58.3669 43.3621 58.3913 43.3724 58.4196L45.5778 63.4053C46.6219 65.7574 45.3197 67.8045 43.2668 67.8045H43.2375Z",
    fill: "url(#paint76_linear_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M86.2023 82.562C79.9262 82.562 74.835 81.8816 74.835 81.0487C74.835 80.2158 79.9203 79.5413 86.1906 79.5413C92.4608 79.5413 97.5579 80.2275 97.5579 81.0604C97.5579 81.8933 92.4784 82.562 86.2023 82.562Z",
    fill: "url(#paint77_radial_607_7366)"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M97.358 73.6289C96.871 75.0135 96.1152 76.2883 95.1341 77.38C94.153 78.4718 92.9659 79.359 91.641 79.9906C90.3161 80.6223 88.8794 80.986 87.4135 81.0609C85.9476 81.1358 84.4814 80.9203 83.099 80.427C81.715 79.9399 80.4409 79.1843 79.3496 78.2037C78.2583 77.223 77.3715 76.0365 76.7399 74.7122C76.1082 73.388 75.7443 71.952 75.669 70.4868C75.5937 69.0215 75.8084 67.5558 76.3009 66.1738C76.7874 64.7893 77.5425 63.5145 78.5229 62.4226C79.5034 61.3307 80.6898 60.4432 82.0141 59.811C83.3384 59.1789 84.7746 58.8144 86.2401 58.7387C87.7056 58.663 89.1716 58.8775 90.5541 59.3698C93.3459 60.3602 95.6305 62.4181 96.9062 65.0916C98.1819 67.7651 98.3445 70.8356 97.358 73.6289Z",
    fill: "#FCCC00"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8275 71.6698C91.5958 72.3321 91.2358 72.9423 90.7679 73.4652C90.3 73.9882 89.7335 74.4136 89.1008 74.7171C88.4681 75.0206 87.7818 75.1963 87.0811 75.234C86.3804 75.2717 85.6792 75.1707 85.0176 74.9369C84.3576 74.7035 83.75 74.3424 83.2297 73.874C82.7093 73.4056 82.2864 72.8393 81.9851 72.2074C81.6839 71.5754 81.5102 70.8903 81.4739 70.1912C81.4377 69.492 81.5397 68.7926 81.774 68.1329C82.2467 66.8007 83.2285 65.7104 84.504 65.1012C85.7796 64.492 87.2447 64.4137 88.578 64.8834C89.905 65.3575 90.9911 66.3366 91.5997 67.6077C92.2083 68.8787 92.2901 70.3387 91.8275 71.6698Z",
    fill: "#EAE9CE"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M97.974 69.1536C97.235 69.5046 96.5761 70.0039 96.0383 70.6204C95.5004 71.237 95.0952 71.9576 94.8477 72.7374C94.5497 73.4999 94.4111 74.3153 94.4404 75.1335C94.4696 75.9516 94.6661 76.755 95.0178 77.4943C96.0574 76.3809 96.8561 75.0651 97.364 73.629C97.8695 72.1942 98.0771 70.6713 97.974 69.1536Z",
    fill: "#EAE9CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_607_7366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 69,
    width: 4,
    height: 9
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M97.974 69.1536C97.235 69.5046 96.5761 70.0039 96.0383 70.6204C95.5004 71.237 95.0952 71.9576 94.8477 72.7374C94.5497 73.4999 94.4111 74.3153 94.4404 75.1335C94.4696 75.9516 94.6661 76.755 95.0178 77.4943C96.0574 76.3809 96.8561 75.0651 97.364 73.629C97.8695 72.1942 98.0771 70.6713 97.974 69.1536Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_607_7366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.1442 71.8928C98.3619 71.9683 98.5547 72.1022 98.7014 72.2799C98.8421 72.4485 98.9371 72.6505 98.9771 72.8665C99.0186 73.1052 99.0186 73.3493 98.9771 73.588C98.9343 73.8655 98.8595 74.1371 98.7542 74.3974C98.6582 74.6586 98.5301 74.9069 98.3729 75.1365C98.2376 75.3359 98.0689 75.5104 97.8743 75.6526C97.7006 75.7769 97.4994 75.8574 97.2878 75.8872C97.0586 75.915 96.8262 75.8826 96.6133 75.7934C96.3876 75.7172 96.1855 75.5838 96.0267 75.4063C95.8883 75.2362 95.7937 75.0348 95.751 74.8197C95.7067 74.5832 95.7067 74.3406 95.751 74.1041C95.7897 73.8283 95.8626 73.5584 95.9681 73.3006C96.0649 73.0368 96.195 72.7865 96.3552 72.5556C96.4868 72.3535 96.6537 72.1767 96.8479 72.0336C97.0221 71.9101 97.2231 71.8297 97.4344 71.799C97.6751 71.7614 97.9215 71.794 98.1442 71.8928ZM97.6925 73.0659C97.5378 73.0011 97.3732 72.9634 97.2057 72.9545C97.0827 72.951 96.9604 72.9751 96.8479 73.0249C96.7526 73.0733 96.6702 73.1437 96.6074 73.2302C96.5444 73.3148 96.4931 73.4075 96.4549 73.5058C96.4178 73.6042 96.3922 73.7066 96.3786 73.8109C96.3668 73.9149 96.383 74.0202 96.4256 74.1158C96.4732 74.2265 96.5454 74.3248 96.6367 74.4033C96.7672 74.5114 96.9163 74.5949 97.0766 74.6496C97.2311 74.716 97.3957 74.7557 97.5635 74.7669C97.684 74.7698 97.8037 74.7478 97.9154 74.7024C98.0112 74.6575 98.094 74.5889 98.1559 74.503C98.2189 74.4184 98.2702 74.3256 98.3084 74.2273C98.3482 74.1298 98.3738 74.0271 98.3846 73.9223C98.3972 73.815 98.3831 73.7061 98.3436 73.6055C98.296 73.4949 98.2237 73.3966 98.1324 73.3181C98.0026 73.2018 97.8538 73.1086 97.6925 73.0425V73.0659Z",
    fill: "black"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6792 70.6493C76.4187 70.2965 77.0782 69.796 77.6169 69.1787C78.1555 68.5613 78.5621 67.8401 78.8114 67.0597C79.1081 66.2967 79.2456 65.4811 79.2153 64.663C79.1851 63.8449 78.9877 63.0417 78.6354 62.3027C77.5983 63.4179 76.7999 64.7333 76.2892 66.1681C75.7832 67.6048 75.5757 69.1297 75.6792 70.6493Z",
    fill: "#EAE9CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_607_7366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 62,
    width: 5,
    height: 9
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6792 70.6493C76.4187 70.2965 77.0782 69.796 77.6169 69.1787C78.1555 68.5613 78.5621 67.8401 78.8114 67.0597C79.1081 66.2967 79.2456 65.4811 79.2153 64.663C79.1851 63.8449 78.9877 63.0417 78.6354 62.3027C77.5983 63.4179 76.7999 64.7333 76.2892 66.1681C75.7832 67.6048 75.5757 69.1297 75.6792 70.6493Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_607_7366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.7668 64.3203C77.9166 64.4868 78.0215 64.6887 78.0718 64.9069C78.1321 65.1403 78.15 65.3827 78.1246 65.6225C78.0974 65.902 78.0383 66.1775 77.9486 66.4436C77.8642 66.7089 77.748 66.963 77.6026 67.2003C77.4831 67.4075 77.3259 67.5905 77.1392 67.7399C76.969 67.877 76.7675 67.9697 76.5526 68.0097C76.3245 68.0473 76.0906 68.0272 75.8722 67.9511C75.6497 67.8832 75.4479 67.7601 75.2857 67.5933C75.1363 67.4265 75.0314 67.2248 74.9807 67.0067C74.9208 66.7732 74.903 66.5309 74.9279 66.2911C74.9501 66.0133 75.0073 65.7394 75.098 65.4758C75.1844 65.2085 75.3026 64.9525 75.4499 64.7133C75.5714 64.5041 75.7305 64.3192 75.9192 64.1678C76.0881 64.0287 76.2902 63.9358 76.5057 63.898C76.7333 63.858 76.9674 63.8762 77.1861 63.9508C77.4101 64.018 77.611 64.1459 77.7668 64.3203ZM76.3063 65.0476C76.1828 65.0478 76.0615 65.0801 75.9544 65.1415C75.8623 65.1925 75.7838 65.2649 75.7256 65.3526C75.6671 65.4423 75.6198 65.5389 75.5848 65.6401C75.5535 65.7391 75.5338 65.8415 75.5262 65.9451C75.5214 66.0506 75.5436 66.1555 75.5907 66.2501C75.6402 66.3612 75.7193 66.4566 75.8194 66.5257C75.9517 66.6289 76.1033 66.7047 76.2652 66.7486C76.4248 66.8076 76.5937 66.8374 76.7638 66.8366C76.8843 66.8393 77.0034 66.811 77.1099 66.7545C77.2019 66.7035 77.2804 66.631 77.3386 66.5433C77.3975 66.4568 77.443 66.3619 77.4735 66.2618C77.5077 66.1615 77.5274 66.0568 77.5322 65.9509C77.539 65.844 77.5188 65.7371 77.4735 65.6401C77.4231 65.5296 77.3466 65.4329 77.2506 65.3585C77.114 65.2588 76.9612 65.1834 76.799 65.1356C76.6413 65.0772 76.4744 65.0474 76.3063 65.0476Z",
    fill: "black"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M86.085 58.748C86.4356 59.4879 86.9348 60.1478 87.5513 60.6866C88.1678 61.2255 88.8886 61.6317 89.6688 61.8802C90.4314 62.1786 91.2472 62.317 92.0655 62.2867C92.8839 62.2565 93.6873 62.0582 94.4257 61.7042C93.3099 60.6678 91.9947 59.8695 90.5603 59.358C89.1256 58.8525 87.6027 58.6449 86.085 58.748Z",
    fill: "#EAE9CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_607_7366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 58,
    width: 9,
    height: 5
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M86.085 58.748C86.4356 59.4879 86.9348 60.1478 87.5513 60.6866C88.1678 61.2255 88.8886 61.6317 89.6688 61.8802C90.4314 62.1786 91.2472 62.317 92.0655 62.2867C92.8839 62.2565 93.6873 62.0582 94.4257 61.7042C93.3099 60.6678 91.9947 59.8695 90.5603 59.358C89.1256 58.8525 87.6027 58.6449 86.085 58.748Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_607_7366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.1997 58.4254C89.3451 58.2893 89.5227 58.1924 89.7159 58.1439C89.9283 58.089 90.1489 58.0731 90.3669 58.097C90.6227 58.1226 90.8746 58.1777 91.1177 58.2612C91.3602 58.3364 91.5926 58.4407 91.8099 58.5721C91.9984 58.6865 92.1668 58.8312 92.3084 59.0003C92.4305 59.154 92.513 59.3352 92.5489 59.5281C92.5878 59.7364 92.5695 59.9512 92.4961 60.1499C92.4371 60.3543 92.3235 60.5388 92.1677 60.6837C92.0233 60.8168 91.8479 60.9116 91.6574 60.9593C91.4454 61.0166 91.2247 61.0345 91.0063 61.0121C90.7532 60.9852 90.5035 60.9321 90.2614 60.8538C90.0182 60.773 89.7842 60.6669 89.5634 60.537C89.3748 60.4226 89.2064 60.2779 89.0648 60.1088C88.9443 59.9513 88.8602 59.769 88.8185 59.5751C88.7844 59.3667 88.8026 59.153 88.8712 58.9533C88.9313 58.751 89.0447 58.5686 89.1997 58.4254ZM89.8684 59.7628C89.8691 59.8735 89.8973 59.9824 89.9505 60.0795C89.9966 60.1648 90.0631 60.2374 90.1441 60.2907C90.2246 60.3476 90.3137 60.3911 90.408 60.4197C90.4991 60.4496 90.5938 60.4674 90.6896 60.4725C90.7844 60.4775 90.879 60.4594 90.9652 60.4197C91.0638 60.3687 91.1499 60.2966 91.2174 60.2086C91.3079 60.0839 91.3772 59.9451 91.4227 59.798C91.4739 59.6527 91.5017 59.5003 91.5049 59.3463C91.503 59.2357 91.4748 59.1272 91.4227 59.0296C91.3783 58.945 91.3139 58.8725 91.235 58.8184C91.1544 58.767 91.0677 58.7256 90.977 58.6953C90.8847 58.6611 90.7878 58.6414 90.6896 58.6366C90.5928 58.6307 90.496 58.6488 90.408 58.6894C90.3064 58.7383 90.218 58.8106 90.1499 58.9005C90.0582 59.0245 89.9888 59.1634 89.9446 59.3111C89.8917 59.4557 89.8659 59.6088 89.8684 59.7628Z",
    fill: "black"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M87.581 81.043C87.227 80.305 86.726 79.6471 86.1087 79.1095C85.4915 78.5719 84.7709 78.166 83.9913 77.9167C83.2287 77.6183 82.4129 77.4799 81.5945 77.5102C80.7762 77.5405 79.9728 77.7387 79.2344 78.0927C80.349 79.1307 81.6645 79.9292 83.0997 80.4389C84.5362 80.9457 86.0616 81.1513 87.581 81.043Z",
    fill: "#EAE9CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_607_7366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 77,
    width: 9,
    height: 5
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M87.581 81.043C87.227 80.305 86.726 79.6471 86.1087 79.1095C85.4915 78.5719 84.7709 78.166 83.9913 77.9167C83.2287 77.6183 82.4129 77.4799 81.5945 77.5102C80.7762 77.5405 79.9728 77.7387 79.2344 78.0927C80.349 79.1307 81.6645 79.9292 83.0997 80.4389C84.5362 80.9457 86.0616 81.1513 87.581 81.043Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_607_7366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.258 79.2831C81.4248 79.135 81.6268 79.0321 81.8446 78.984C82.0781 78.9239 82.3204 78.9061 82.5602 78.9312C82.8397 78.9584 83.1152 79.0175 83.3814 79.1072C83.6454 79.1921 83.8992 79.3063 84.138 79.4474C84.3442 79.5707 84.5269 79.7296 84.6776 79.9166C84.8147 80.0868 84.9074 80.2883 84.9474 80.5032C84.9879 80.7312 84.9677 80.9659 84.8888 81.1836C84.8209 81.4062 84.6979 81.608 84.531 81.7701C84.371 81.9131 84.1804 82.0174 83.9738 82.0751C83.7403 82.1352 83.4979 82.1531 83.2582 82.1279C82.9806 82.1001 82.7072 82.0411 82.4429 81.952C82.1758 81.8674 81.9198 81.7512 81.6803 81.6059C81.4723 81.4828 81.2876 81.324 81.1349 81.1367C80.9977 80.9665 80.905 80.7649 80.865 80.5501C80.8246 80.3221 80.8448 80.0874 80.9237 79.8697C80.9824 79.6485 81.0976 79.4464 81.258 79.2831ZM81.9854 80.7495C81.9891 80.8725 82.0212 80.993 82.0792 81.1015C82.1303 81.1935 82.2027 81.272 82.2904 81.3302C82.3807 81.3876 82.4771 81.4348 82.5778 81.471C82.6765 81.5028 82.7791 81.5205 82.8828 81.5238C82.988 81.5338 83.0938 81.5135 83.1878 81.4651C83.2977 81.4137 83.3926 81.3349 83.4635 81.2364C83.5653 81.1024 83.6428 80.9515 83.6922 80.7906C83.7468 80.63 83.7746 80.4616 83.7743 80.292C83.777 80.1715 83.7488 80.0524 83.6922 79.9459C83.6412 79.8539 83.5688 79.7754 83.4811 79.7172C83.3945 79.6583 83.2996 79.6128 83.1995 79.5823C83.0987 79.549 82.9944 79.5274 82.8886 79.5178C82.7819 79.5139 82.6757 79.5339 82.5778 79.5764C82.4684 79.6312 82.3723 79.7093 82.2962 79.8052C82.1976 79.9424 82.1223 80.0951 82.0733 80.2568C82.0129 80.4142 81.9812 80.581 81.9795 80.7495H81.9854Z",
    fill: "black"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6593 70.8604C88.5066 71.264 88.2993 71.6449 88.0434 71.9924C87.8447 72.2623 87.5957 72.4914 87.3102 72.6669C87.0657 72.8173 86.7874 72.904 86.5008 72.9192C86.2141 72.936 85.9274 72.8879 85.662 72.7784C85.3945 72.6774 85.1523 72.5193 84.9523 72.315C84.754 72.1086 84.609 71.857 84.53 71.5818C84.4428 71.2591 84.417 70.9229 84.4537 70.5906C84.5029 70.1618 84.6094 69.7416 84.7705 69.3412C84.914 68.9391 85.1113 68.5583 85.357 68.2092C85.5557 67.9392 85.8047 67.7102 86.0902 67.5346C86.333 67.3852 86.6091 67.2985 86.8938 67.2824C87.1785 67.2661 87.4632 67.3142 87.7267 67.4232C87.9959 67.5241 88.24 67.6822 88.4423 67.8865C88.6427 68.0923 88.7897 68.3441 88.8704 68.6197C88.9597 68.9421 88.9876 69.2784 88.9526 69.611C88.9116 70.0388 88.813 70.459 88.6593 70.8604ZM87.4862 70.4087C87.611 70.1141 87.7053 69.8075 87.7677 69.4937C87.8108 69.2913 87.8207 69.0833 87.7971 68.8778C87.7855 68.7411 87.7346 68.6108 87.6504 68.5025C87.5763 68.4238 87.4863 68.3618 87.3865 68.3206C87.2841 68.2801 87.1731 68.266 87.0639 68.2796C86.9313 68.3024 86.8075 68.3612 86.7061 68.4496C86.5538 68.5898 86.4233 68.7519 86.3189 68.9306C86.1548 69.2042 86.0174 69.493 85.9084 69.7928C85.7817 70.0888 85.6873 70.3975 85.6268 70.7137C85.5859 70.9064 85.5721 71.1038 85.5858 71.3003C85.5973 71.4369 85.6483 71.5673 85.7324 71.6757C85.8043 71.7568 85.8949 71.8192 85.9963 71.8575C86.0967 71.898 86.2057 71.9122 86.3131 71.8986C86.4479 71.8771 86.5739 71.8182 86.6767 71.7285C86.8314 71.5912 86.9639 71.431 87.0697 71.2533C87.2429 70.9874 87.3883 70.7044 87.5038 70.4087H87.4862Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_607_7366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 58,
    width: 23,
    height: 24
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9979 69.8985C98.0018 71.3645 97.7164 72.8168 97.158 74.1723C96.5997 75.5278 95.7794 76.7598 94.7442 77.7978C93.7089 78.8358 92.4791 79.6593 91.125 80.2212C89.771 80.7831 88.3194 81.0723 86.8535 81.0723C83.8951 81.0646 81.0605 79.8839 78.9713 77.7892C76.8822 75.6946 75.709 72.8569 75.709 69.8985C75.7167 66.9452 76.8934 64.1151 78.9817 62.0267C81.07 59.9384 83.9001 58.7618 86.8535 58.754C89.8091 58.754 92.6438 59.9282 94.7338 62.0182C96.8238 64.1082 97.9979 66.9428 97.9979 69.8985Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_607_7366)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M104.626 48.1785C109.195 56.5368 104.409 67.9394 93.9328 73.6406C83.457 79.3419 71.2685 77.1893 66.6992 68.8309C62.13 60.4726 66.9221 49.0642 77.392 43.3629C87.862 37.6616 100.056 39.8143 104.626 48.1785Z",
    fill: "url(#paint78_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.57,
    d: "M83.9315 43.2631C88.0022 40.8289 96.7183 47.9555 103.393 59.1293C110.068 70.3031 112.192 81.3772 108.086 83.8114C103.98 86.2456 95.3047 79.119 88.6239 67.9745C81.9431 56.83 79.8608 45.709 83.9315 43.2631Z",
    fill: "url(#paint79_radial_607_7366)"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M96.4197 65.734C95.643 63.8835 94.3391 62.3023 92.6703 61.1874C91.0016 60.0725 89.0418 59.473 87.0349 59.4637C86.812 59.4637 86.595 59.4637 86.3838 59.4637C88.2744 59.5974 90.0909 60.2526 91.6316 61.3563C93.1723 62.4601 94.3769 63.9693 95.1117 65.7164C95.6628 67.0152 95.948 68.4113 95.9505 69.8223C95.948 71.2332 95.6628 72.6293 95.1117 73.9281C94.3806 75.6831 93.1763 77.2003 91.633 78.3106C90.0898 79.4209 88.2684 80.0806 86.3721 80.2159C86.5832 80.2159 86.8003 80.2159 87.0232 80.2159C89.03 80.2066 90.9899 79.6072 92.6586 78.4923C94.3273 77.3774 95.6312 75.7962 96.408 73.9457C96.9612 72.6475 97.2465 71.251 97.2467 69.8398C97.2514 68.4294 96.97 67.0326 96.4197 65.734Z",
    fill: "url(#paint80_linear_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.89,
    d: "M93.7629 58.2319C95.5988 61.6104 93.4227 66.3263 88.9063 68.7898C84.3898 71.2533 79.2458 70.4732 77.4157 67.0888C75.5857 63.7044 77.7501 58.9944 82.2665 56.5309C86.7829 54.0673 91.9505 54.8475 93.7629 58.2319Z",
    fill: "url(#paint81_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.62,
    d: "M90.1257 61.2233C90.7416 62.7073 89.4218 64.6605 87.1929 65.5814C84.964 66.5022 82.6472 66.0506 82.0313 64.5666C81.4154 63.0827 82.7351 61.1294 84.964 60.2086C87.1929 59.2877 89.5098 59.7393 90.1257 61.2233Z",
    fill: "url(#paint82_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M96.7127 89.9291C82.2366 94.4455 69.3325 94.3928 67.8896 89.8001C66.4467 85.2074 77.0163 77.8227 91.4924 73.3004C105.968 68.7781 118.873 68.8367 120.316 73.4294C121.758 78.0221 111.189 85.4068 96.7127 89.9291Z",
    fill: "url(#paint83_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M76.3947 88.3278C67.0099 84.0402 60.9919 77.1834 62.904 72.9837C64.8162 68.784 73.9547 68.8778 83.316 73.1596C92.6774 77.4414 98.7247 84.3041 96.8067 88.5097C94.8887 92.7152 85.7619 92.6155 76.3947 88.3278Z",
    fill: "url(#paint84_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M69.2564 72.0042C65.8486 62.285 66.5994 53.1641 70.9398 51.6332C75.2803 50.1023 81.5681 56.7362 84.976 66.4554C88.3839 76.1745 87.6331 85.2954 83.2926 86.8263C78.9521 88.3572 72.6643 81.6998 69.2564 72.0042Z",
    fill: "url(#paint85_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M57.5726 77.7524C53.2263 67.781 53.0562 58.2085 57.1855 56.4078C61.3148 54.6071 68.1833 61.2292 72.5297 71.2123C76.876 81.1954 77.0403 90.7562 72.9109 92.5569C68.7816 94.3576 61.9131 87.7355 57.5726 77.7524Z",
    fill: "url(#paint86_radial_607_7366)"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.6795 68.4848C87.6091 68.4017 87.5209 68.3356 87.4214 68.2912C87.3203 68.2538 87.212 68.2398 87.1047 68.2501C86.9699 68.2716 86.8439 68.3306 86.741 68.4203C86.5852 68.5563 86.4525 68.7168 86.3481 68.8954C86.1829 69.1681 86.0416 69.4546 85.9257 69.7517C85.7997 70.0469 85.7015 70.3532 85.6325 70.6667C85.5893 70.859 85.5754 71.0568 85.5914 71.2533C85.5996 71.3879 85.6487 71.5168 85.7322 71.6228C85.8002 71.7083 85.8891 71.775 85.9902 71.8164C86.0913 71.8541 86.1997 71.8682 86.307 71.8574C86.4443 71.8387 86.573 71.7795 86.6765 71.6873C86.833 71.5526 86.9676 71.3943 87.0754 71.2181C87.2416 70.9438 87.3829 70.6553 87.4977 70.3559C87.6244 70.0629 87.7226 69.7585 87.791 69.4467C87.8354 69.2446 87.8473 69.0367 87.8262 68.8308C87.8093 68.7044 87.7586 68.5848 87.6795 68.4848Z",
    fill: "url(#paint87_linear_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6357 64.8659C87.3071 64.3797 85.8399 64.4408 84.5564 65.0358C83.2729 65.6308 82.2781 66.711 81.7906 68.0391C81.5491 68.6969 81.4396 69.3958 81.4684 70.0959C81.4972 70.7961 81.6637 71.4837 81.9584 72.1194C82.2531 72.7551 82.6702 73.3265 83.1859 73.8009C83.7016 74.2753 84.3058 74.6434 84.9639 74.8841C85.6212 75.1256 86.3198 75.235 87.0195 75.2062C87.7192 75.1773 88.4063 75.0107 89.0416 74.716C89.6768 74.4212 90.2477 74.0041 90.7216 73.4885C91.1954 72.9728 91.5629 72.3688 91.8031 71.7109C92.2895 70.3831 92.2292 68.9165 91.6354 67.6332C91.0415 66.3498 89.9627 65.3545 88.6357 64.8659ZM88.6357 70.8663C88.4853 71.2728 88.2779 71.6559 88.0198 72.0042C87.819 72.2728 87.568 72.4999 87.2807 72.6729C87.0327 72.8185 86.7528 72.901 86.4654 72.9133C86.1786 72.9249 85.8926 72.8749 85.6267 72.7667C85.3602 72.6615 85.12 72.4994 84.9228 72.2916C84.7287 72.0839 84.5879 71.8324 84.5122 71.5584C84.4266 71.2333 84.4046 70.8947 84.4477 70.5613C84.4987 70.1335 84.6093 69.7149 84.7762 69.3178C84.9326 68.9153 85.1438 68.5363 85.4038 68.1916C85.6042 67.9248 85.8529 67.698 86.137 67.5229C86.3842 67.3804 86.6615 67.298 86.9464 67.2825C87.232 67.2696 87.5168 67.3218 87.7793 67.435C88.0464 67.5395 88.2883 67.6994 88.489 67.9042C88.6868 68.1101 88.8299 68.3621 88.9055 68.6374C88.996 68.9616 89.02 69.3008 88.9759 69.6345C88.9246 70.0585 88.814 70.4731 88.6474 70.8663H88.6357Z",
    fill: "url(#paint88_linear_607_7366)"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M69.4678 85.9229C62.7635 85.9229 57.332 85.0665 57.3262 84.0225C57.3203 82.9784 62.7576 82.1396 69.4619 82.1396C76.1662 82.1396 81.6035 82.996 81.6035 84.0401C81.6035 85.0841 76.1721 85.9287 69.4678 85.9229Z",
    fill: "url(#paint89_radial_607_7366)"
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M81.762 66.3263C82.3944 67.9408 82.7026 69.664 82.6691 71.3976C82.6355 73.1312 82.2608 74.8413 81.5663 76.4301C80.8719 78.0188 79.8713 79.4553 78.6217 80.6574C77.3721 81.8595 75.8979 82.8036 74.2834 83.436C72.6686 84.0693 70.9448 84.3783 69.2106 84.3452C67.4763 84.3121 65.7656 83.9376 64.1761 83.243C62.5866 82.5485 61.1496 81.5476 59.9471 80.2976C58.7446 79.0475 57.8002 77.5727 57.1679 75.9575C55.892 72.6959 55.963 69.0613 57.3653 65.8521C58.7675 62.6429 61.3863 60.1215 64.6464 58.8419C67.9087 57.5664 71.5439 57.6382 74.7533 59.0416C77.9626 60.445 80.4835 63.0652 81.762 66.3263Z",
    fill: "#39B200"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3332 68.8427C75.6351 69.6137 75.7823 70.4367 75.7662 71.2646C75.7501 72.0925 75.5711 72.9091 75.2394 73.6679C74.9077 74.4266 74.4298 75.1125 73.833 75.6866C73.2362 76.2606 72.5321 76.7114 71.7611 77.0133C70.99 77.3153 70.1671 77.4624 69.3392 77.4463C68.5113 77.4303 67.6947 77.2513 66.9359 76.9195C66.1772 76.5878 65.4913 76.1099 64.9172 75.5131C64.3432 74.9163 63.8924 74.2123 63.5904 73.4413C63.2885 72.6702 63.1413 71.8473 63.1574 71.0193C63.1735 70.1914 63.3525 69.3748 63.6842 68.6161C64.0159 67.8574 64.4938 67.1714 65.0906 66.5974C65.6874 66.0234 66.3915 65.5726 67.1625 65.2706C67.9336 64.9687 68.7565 64.8215 69.5844 64.8376C70.4123 64.8537 71.229 65.0327 71.9877 65.3644C72.7464 65.6961 73.4324 66.174 74.0064 66.7708C74.5804 67.3676 75.0313 68.0716 75.3332 68.8427Z",
    fill: "#EAE9CE"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8985 70.9072C66.824 70.6101 66.8061 70.3017 66.8457 69.9981C66.8787 69.7298 66.9645 69.4706 67.0979 69.2355C67.2337 69.0091 67.4108 68.8102 67.6199 68.649C67.8469 68.4689 68.1001 68.3244 68.3707 68.2208C68.6474 68.1095 68.9409 68.0461 69.2388 68.0331C69.4919 68.023 69.7447 68.0608 69.9837 68.1445C70.2037 68.2237 70.4039 68.3498 70.5703 68.5141C70.7333 68.6803 70.8575 68.8807 70.934 69.1006C71.0036 69.2742 71.0528 69.4553 71.0806 69.6402C71.1076 69.7915 71.1076 69.9464 71.0806 70.0978C71.0452 70.2361 70.9856 70.3672 70.9046 70.4849C70.8114 70.6128 70.7031 70.729 70.582 70.8309C70.9196 70.7903 71.2608 70.8673 71.5482 71.049C71.8356 71.2306 72.0516 71.5058 72.1598 71.8281C72.2828 72.1208 72.337 72.4379 72.3182 72.7549C72.3002 73.0357 72.218 73.3086 72.0777 73.5526C71.9387 73.7989 71.7511 74.0144 71.5264 74.186C71.2908 74.3738 71.0276 74.5241 70.7463 74.6318C70.484 74.741 70.2075 74.8122 69.9251 74.843C69.6815 74.8731 69.4344 74.8551 69.1978 74.7902C68.9553 74.7184 68.7271 74.6053 68.5232 74.4558C68.2879 74.2838 68.0717 74.0871 67.878 73.8693L68.3766 73.4C68.4865 73.2897 68.6279 73.2159 68.7813 73.1889C68.8433 73.176 68.9074 73.1767 68.9692 73.1908C69.0309 73.205 69.0889 73.2323 69.1391 73.271C69.3064 73.4299 69.5067 73.5501 69.7256 73.6229C69.9193 73.6797 70.1267 73.6673 70.3122 73.5877C70.4434 73.538 70.5631 73.4622 70.6641 73.3649C70.7509 73.2803 70.8188 73.1783 70.8636 73.0657C70.9033 72.9608 70.9232 72.8494 70.9222 72.7372C70.9218 72.6246 70.8999 72.5132 70.8577 72.4088C70.8136 72.2887 70.7586 72.1728 70.6935 72.0627C70.6328 71.9637 70.5394 71.889 70.4295 71.8515C70.2813 71.8138 70.1261 71.8138 69.9779 71.8515C69.7223 71.899 69.4726 71.9737 69.2329 72.0744L68.881 71.1594C69.0871 71.0818 69.2838 70.9815 69.4676 70.8603C69.5907 70.7801 69.6948 70.674 69.7726 70.5494C69.8295 70.452 69.8542 70.3391 69.843 70.2268C69.8339 70.1097 69.8062 69.9949 69.7609 69.8866C69.6948 69.678 69.5523 69.502 69.362 69.3939C69.2656 69.3488 69.1605 69.3255 69.054 69.3255C68.9476 69.3255 68.8425 69.3488 68.7461 69.3939C68.5672 69.4582 68.4146 69.5799 68.3121 69.74C68.2213 69.89 68.1764 70.0633 68.183 70.2385C68.1956 70.3806 68.156 70.5224 68.0716 70.6374C67.963 70.7432 67.823 70.8111 67.6727 70.8309L66.8985 70.9072Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8466 61.8451C78.4614 62.7338 78.2627 63.692 78.2627 64.6605C78.2627 65.6291 78.4614 66.5873 78.8466 67.476C79.1735 68.386 79.6829 69.2196 80.3436 69.9256C81.0042 70.6317 81.8022 71.1953 82.6885 71.5819C82.7499 69.7791 82.4425 67.9827 81.7852 66.3029C81.1189 64.6327 80.119 63.1158 78.8466 61.8451Z",
    fill: "#EAE9CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_607_7366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 61,
    width: 5,
    height: 11
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8466 61.8451C78.4614 62.7338 78.2627 63.692 78.2627 64.6605C78.2627 65.6291 78.4614 66.5873 78.8466 67.476C79.1735 68.386 79.6829 69.2196 80.3436 69.9256C81.0042 70.6317 81.8022 71.1953 82.6885 71.5819C82.7499 69.7791 82.4425 67.9827 81.7852 66.3029C81.1189 64.6327 80.119 63.1158 78.8466 61.8451Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_607_7366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.6621 68.6256C81.5364 68.6871 81.3929 68.7017 81.2574 68.6666C81.0931 68.6241 80.942 68.5415 80.8175 68.4262C80.6489 68.2795 80.5045 68.1073 80.3893 67.9159C80.2449 67.6816 80.1231 67.4341 80.0257 67.1768C79.9183 66.9147 79.8416 66.6412 79.7969 66.3615C79.7669 66.1671 79.7669 65.9693 79.7969 65.7749C79.8164 65.6407 79.8733 65.5147 79.9611 65.4113C79.9981 65.3722 80.0426 65.3411 80.0921 65.3199C80.1415 65.2987 80.1948 65.2879 80.2485 65.2881C80.338 65.2817 80.4278 65.2937 80.5125 65.3233C80.594 65.3525 80.6695 65.3962 80.7354 65.4523C80.8103 65.5142 80.8773 65.5851 80.9348 65.6635C81.0047 65.7535 81.0694 65.8475 81.1284 65.945C81.0169 65.4289 81.0932 65.1766 81.3337 65.1708C81.445 65.1724 81.5525 65.2117 81.6387 65.2822C81.7453 65.3624 81.8401 65.4572 81.9202 65.5638C82.0135 65.6895 82.0959 65.8229 82.1666 65.9626C82.2506 66.1154 82.3231 66.2742 82.3836 66.4377C82.4468 66.5911 82.5016 66.7477 82.5478 66.907C82.5829 67.0379 82.6084 67.1712 82.6241 67.3058C82.6387 67.4286 82.6387 67.5526 82.6241 67.6754C82.6108 67.8012 82.5832 67.9252 82.542 68.0449L82.3367 67.7047C82.2835 67.6187 82.2421 67.526 82.2135 67.429C82.1951 67.3578 82.1951 67.2832 82.2135 67.212C82.2304 67.1012 82.2304 66.9885 82.2135 66.8777C82.1979 66.763 82.1683 66.6508 82.1255 66.5433C82.0966 66.4615 82.0592 66.3828 82.0141 66.3087C81.9788 66.2532 81.9395 66.2003 81.8967 66.1503C81.8625 66.115 81.8229 66.0853 81.7794 66.0623C81.7471 66.0512 81.712 66.0512 81.6797 66.0623C81.6421 66.0687 81.6062 66.0827 81.5741 66.1034C81.5578 66.1203 81.5456 66.1407 81.5385 66.1631C81.5314 66.1855 81.5295 66.2092 81.5331 66.2324C81.5324 66.3302 81.5483 66.4274 81.58 66.5199C81.6152 66.6489 81.6739 66.819 81.756 67.036L81.4568 67.1827C81.3947 67.0227 81.3242 66.866 81.2457 66.7134C81.1968 66.6193 81.1378 66.5308 81.0697 66.4495C81.0293 66.3986 80.9739 66.3616 80.9113 66.3439C80.8612 66.3321 80.809 66.3321 80.7589 66.3439C80.7067 66.3551 80.6592 66.3818 80.6225 66.4206C80.5859 66.4593 80.5618 66.5082 80.5536 66.5609C80.5381 66.732 80.5685 66.904 80.6415 67.0595C80.693 67.2077 80.7749 67.3436 80.882 67.4583C80.9512 67.5353 81.0441 67.5869 81.146 67.605C81.2249 67.6211 81.2956 67.6648 81.3454 67.7282C81.4099 67.8271 81.4575 67.9361 81.4862 68.0508L81.6621 68.6256Z",
    fill: "black"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0834 80.4388C60.4685 79.5501 60.6673 78.5919 60.6673 77.6233C60.6673 76.6548 60.4685 75.6965 60.0834 74.8079C59.7586 73.8976 59.2507 73.0636 58.5909 72.3574C57.9311 71.6512 57.1335 71.0878 56.2473 70.702C56.1802 72.5052 56.4878 74.3027 57.1506 75.981C57.813 77.6519 58.8111 79.1691 60.0834 80.4388Z",
    fill: "#EAE9CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_607_7366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 70,
    width: 5,
    height: 11
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0834 80.4388C60.4685 79.5501 60.6673 78.5919 60.6673 77.6233C60.6673 76.6548 60.4685 75.6965 60.0834 74.8079C59.7586 73.8976 59.2507 73.0636 58.5909 72.3574C57.9311 71.6512 57.1335 71.0878 56.2473 70.702C56.1802 72.5052 56.4878 74.3027 57.1506 75.981C57.813 77.6519 58.8111 79.1691 60.0834 80.4388Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_607_7366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2617 73.6582C57.3897 73.5978 57.5348 73.5832 57.6723 73.6172C57.8352 73.6588 57.9847 73.7416 58.1063 73.8576C58.2751 74.0041 58.4196 74.1764 58.5345 74.368C58.6786 74.6033 58.8022 74.8505 58.904 75.107C59.0106 75.3693 59.0874 75.6428 59.1328 75.9223C59.163 76.1167 59.163 76.3145 59.1328 76.5089C59.116 76.6439 59.0587 76.7706 58.9685 76.8725C58.933 76.9118 58.8895 76.943 58.8409 76.9642C58.7924 76.9855 58.74 76.9962 58.687 76.9957C58.5956 77.0026 58.5038 76.9906 58.4172 76.9605C58.3363 76.9301 58.261 76.8864 58.1943 76.8315C58.1206 76.7683 58.0537 76.6975 57.9949 76.6203C57.9249 76.5316 57.8622 76.4374 57.8072 76.3388C57.9128 76.8549 57.8365 77.1072 57.596 77.113C57.4848 77.1105 57.3776 77.0713 57.291 77.0016C57.1863 76.9212 57.0935 76.8264 57.0153 76.72C56.92 76.5945 56.8356 76.4611 56.7631 76.3212C56.6791 76.1684 56.6066 76.0096 56.5461 75.8461C56.482 75.6937 56.429 75.5369 56.3877 75.3768C56.348 75.2467 56.3206 75.1132 56.3056 74.978C56.294 74.8551 56.294 74.7314 56.3056 74.6085C56.3189 74.4826 56.3464 74.3586 56.3877 74.2389L56.593 74.5791C56.6485 74.6639 56.6901 74.7569 56.7162 74.8548C56.7346 74.926 56.7346 75.0006 56.7162 75.0718C56.6962 75.1824 56.6962 75.2956 56.7162 75.4062C56.727 75.521 56.7546 75.6337 56.7983 75.7405C56.8296 75.8213 56.8669 75.8998 56.9098 75.9751C56.945 76.0322 56.9863 76.0853 57.0329 76.1335C57.0639 76.1698 57.1018 76.1997 57.1444 76.2215C57.1787 76.2327 57.2156 76.2327 57.2499 76.2215C57.2854 76.2139 57.3192 76.2 57.3497 76.1804C57.3657 76.1631 57.3782 76.1428 57.3862 76.1207C57.3943 76.0985 57.3978 76.0749 57.3966 76.0514C57.3917 75.9537 57.3739 75.857 57.3438 75.7639C57.2956 75.5885 57.2368 75.4162 57.1678 75.2478L57.4728 75.1012C57.5491 75.3006 57.6195 75.4531 57.6781 75.5704C57.727 75.6645 57.786 75.7531 57.8541 75.8344C57.8945 75.8852 57.9499 75.9222 58.0125 75.9399C58.0626 75.9517 58.1148 75.9517 58.165 75.9399C58.2175 75.9295 58.2654 75.903 58.3022 75.8641C58.339 75.8253 58.3628 75.7759 58.3703 75.7229C58.3915 75.5523 58.363 75.3791 58.2881 75.2243C58.2324 75.0768 58.1488 74.9413 58.0418 74.8255C57.9757 74.7478 57.8843 74.6959 57.7837 74.6788C57.7026 74.664 57.6297 74.6202 57.5784 74.5556C57.5163 74.4554 57.4689 74.3468 57.4376 74.2331L57.2617 73.6582Z",
    fill: "black"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1709 61.7572C61.0588 62.1412 62.016 62.3393 62.9834 62.3393C63.9508 62.3393 64.908 62.1412 65.7959 61.7572C66.7059 61.4303 67.5395 60.9208 68.2456 60.2602C68.9516 59.5995 69.5152 58.8016 69.9018 57.9153C68.099 57.8544 66.3028 58.1618 64.6228 58.8186C62.9547 59.4858 61.44 60.4856 60.1709 61.7572Z",
    fill: "#EAE9CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_607_7366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 57,
    width: 10,
    height: 6
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1709 61.7572C61.0588 62.1412 62.016 62.3393 62.9834 62.3393C63.9508 62.3393 64.908 62.1412 65.7959 61.7572C66.7059 61.4303 67.5395 60.9208 68.2456 60.2602C68.9516 59.5995 69.5152 58.8016 69.9018 57.9153C68.099 57.8544 66.3028 58.1618 64.6228 58.8186C62.9547 59.4858 61.44 60.4856 60.1709 61.7572Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_607_7366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9519 58.9416C67.0134 59.0673 67.028 59.2108 66.9929 59.3463C66.9478 59.5096 66.8655 59.6601 66.7524 59.7862C66.6031 59.952 66.4313 60.0961 66.2421 60.2144C66.0058 60.3588 65.7564 60.4806 65.4972 60.5781C65.2369 60.6846 64.9653 60.7613 64.6878 60.8068C64.4934 60.8368 64.2956 60.8368 64.1012 60.8068C63.9666 60.7886 63.8402 60.7316 63.7376 60.6426C63.6591 60.567 63.6128 60.4641 63.6085 60.3552C63.6069 60.2655 63.6208 60.1762 63.6496 60.0913C63.6788 60.0098 63.7225 59.9342 63.7786 59.8684C63.8386 59.79 63.9097 59.7208 63.9898 59.6631L64.2713 59.4754C63.7552 59.5868 63.5029 59.5106 63.4971 59.2701C63.4992 59.1598 63.5361 59.0531 63.6027 58.9651C63.6828 58.8585 63.7776 58.7637 63.8842 58.6835C64.0108 58.5915 64.1441 58.5092 64.283 58.4372C64.4369 58.3554 64.5956 58.2829 64.7582 58.2202C64.9341 58.1498 65.0866 58.097 65.2274 58.0559C65.3604 58.0213 65.4956 57.9958 65.6321 57.9797C65.7549 57.9651 65.8789 57.9651 66.0017 57.9797C66.1255 57.9937 66.2475 58.0212 66.3653 58.0618L66.0251 58.2671C65.9409 58.3236 65.8477 58.3653 65.7494 58.3902C65.6803 58.4089 65.6074 58.4089 65.5383 58.3902C65.429 58.3636 65.3162 58.3537 65.2039 58.3609C65.089 58.3751 64.9766 58.4047 64.8696 58.4489C64.7877 58.4779 64.7091 58.5152 64.635 58.5604C64.5795 58.5957 64.5266 58.6349 64.4766 58.6777C64.4413 58.7119 64.4116 58.7515 64.3886 58.795C64.3779 58.8273 64.3779 58.8623 64.3886 58.8947C64.397 58.9327 64.4129 58.9686 64.4356 59.0003C64.4356 59.0003 64.5001 59.0413 64.5646 59.0413C64.6623 59.0411 64.7593 59.0253 64.852 58.9944C64.9752 58.9592 65.1511 58.9006 65.3682 58.8185L65.509 59.1176C65.3154 59.1997 65.157 59.2642 65.0397 59.3287C64.9481 59.3789 64.8617 59.4378 64.7816 59.5047C64.7276 59.5434 64.6883 59.5992 64.6702 59.6631C64.6584 59.7132 64.6584 59.7654 64.6702 59.8156C64.6814 59.8677 64.7081 59.9152 64.7469 59.9519C64.7856 59.9885 64.8345 60.0126 64.8872 60.0209C65.0583 60.0369 65.2305 60.0065 65.3858 59.9329C65.534 59.8814 65.6699 59.7995 65.7846 59.6924C65.8627 59.6233 65.9163 59.5306 65.9371 59.4285C65.9428 59.3885 65.9567 59.3502 65.9779 59.3159C65.9991 59.2816 66.0272 59.252 66.0603 59.229C66.1586 59.1633 66.2679 59.1157 66.3829 59.0882L66.9519 58.9416Z",
    fill: "black"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7651 80.5209C77.8764 80.1357 76.9182 79.937 75.9496 79.937C74.9811 79.937 74.0228 80.1357 73.1342 80.5209C72.2239 80.8456 71.3899 81.3536 70.6837 82.0134C69.9774 82.6732 69.4141 83.4708 69.0283 84.3569C70.8313 84.4211 72.6282 84.1137 74.3073 83.4537C75.977 82.7891 77.4938 81.7912 78.7651 80.5209Z",
    fill: "#EAE9CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_607_7366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 79,
    width: 10,
    height: 6
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7651 80.5209C77.8764 80.1357 76.9182 79.937 75.9496 79.937C74.9811 79.937 74.0228 80.1357 73.1342 80.5209C72.2239 80.8456 71.3899 81.3536 70.6837 82.0134C69.9774 82.6732 69.4141 83.4708 69.0283 84.3569C70.8313 84.4211 72.6282 84.1137 74.3073 83.4537C75.977 82.7891 77.4938 81.7912 78.7651 80.5209Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_607_7366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.008 83.3422C71.945 83.2148 71.9304 83.0689 71.9669 82.9316C72.0087 82.77 72.0892 82.621 72.2016 82.4975C72.3502 82.3287 72.5244 82.1842 72.7177 82.0693C72.9531 81.9252 73.2003 81.8016 73.4568 81.6998C73.7189 81.5925 73.9924 81.5157 74.2721 81.4711C74.4664 81.4408 74.6643 81.4408 74.8586 81.4711C74.9936 81.4879 75.1204 81.5451 75.2223 81.6353C75.2978 81.71 75.3418 81.8107 75.3455 81.9168C75.3505 82.0086 75.3365 82.1005 75.3044 82.1866C75.2761 82.2673 75.2345 82.3427 75.1812 82.4095C75.1181 82.4832 75.0473 82.5501 74.9701 82.609C74.8813 82.6789 74.7872 82.7417 74.6885 82.7967C75.1988 82.6911 75.4569 82.7967 75.4569 83.0019C75.4578 83.1145 75.4206 83.2241 75.3514 83.3128C75.271 83.4175 75.1762 83.5103 75.0698 83.5885C74.9443 83.6838 74.8109 83.7682 74.671 83.8407C74.5182 83.9247 74.3594 83.9973 74.1958 84.0577C74.0425 84.1192 73.8858 84.1721 73.7266 84.2161C73.5946 84.2564 73.4591 84.2839 73.3219 84.2982C73.2009 84.3099 73.0792 84.3099 72.9582 84.2982C72.8328 84.2821 72.7091 84.2546 72.5887 84.2161L72.9289 84.005C73.0151 83.9536 73.1078 83.9142 73.2046 83.8876C73.2757 83.869 73.3505 83.869 73.4216 83.8876C73.5304 83.9045 73.6412 83.9045 73.7501 83.8876C73.8669 83.8774 73.9816 83.8497 74.0903 83.8055C74.1718 83.7736 74.2504 83.7343 74.3249 83.6882C74.383 83.6569 74.4363 83.6173 74.4833 83.5709C74.518 83.5398 74.5459 83.5019 74.5654 83.4595C74.5758 83.4251 74.5758 83.3883 74.5654 83.3539C74.5569 83.3177 74.5409 83.2837 74.5184 83.2542C74.5184 83.2542 74.4598 83.2072 74.3894 83.2072C74.2937 83.2127 74.1991 83.2305 74.1079 83.26C73.9324 83.3082 73.76 83.367 73.5917 83.436L73.4451 83.131C73.6061 83.0713 73.7628 83.0008 73.9143 82.9198C74.0093 82.8748 74.098 82.8177 74.1783 82.7497C74.2291 82.7093 74.2661 82.6539 74.2838 82.5914C74.2956 82.5412 74.2956 82.489 74.2838 82.4388C74.2726 82.3867 74.2459 82.3392 74.2071 82.3026C74.1684 82.2659 74.1195 82.2419 74.0668 82.2336C73.8962 82.2119 73.7229 82.2405 73.5682 82.3157C73.4207 82.3714 73.2852 82.455 73.1694 82.562C73.0896 82.6264 73.0372 82.7186 73.0227 82.8201C73.0081 82.8997 72.9642 82.9709 72.8996 83.0196C72.7996 83.0874 72.6884 83.137 72.5711 83.1662L72.008 83.3422Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_607_7366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 57,
    width: 27,
    height: 28
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3277 74.1834C84.0188 67.0903 79.6397 59.9692 72.5465 58.2781C65.4534 56.587 58.3323 60.9662 56.6412 68.0593C54.95 75.1524 59.3292 82.2735 66.4224 83.9647C73.5155 85.6558 80.6366 81.2766 82.3277 74.1834Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_607_7366)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M74.9688 49.3867C82.1013 55.4575 81.2567 68.1563 73.0802 77.7171C64.9036 87.2779 52.4981 90.1285 45.3656 84.0519C38.2332 77.9752 39.0837 65.2822 47.2543 55.7215C55.425 46.1607 67.8423 43.3101 74.9688 49.3867Z",
    fill: "url(#paint90_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M74.8579 58.4489C77.2041 61.6984 74.8579 67.3703 69.6552 71.1184C64.4524 74.8665 58.3171 75.277 55.9768 72.0275C53.6365 68.7781 55.9768 63.1061 61.1736 59.3581C66.3705 55.61 72.5175 55.1994 74.8579 58.4489Z",
    fill: "url(#paint91_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M67.0327 62.1559C68.3935 63.4757 67.7483 66.3556 65.5839 68.608C63.4196 70.8604 60.5631 71.5759 59.1964 70.2562C57.8297 68.9365 58.4749 66.0565 60.6393 63.8041C62.8037 61.5518 65.666 60.8597 67.0327 62.1559Z",
    fill: "url(#paint92_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M69.3795 47.803C74.3593 44.5828 82.6004 48.4834 87.7796 56.5191C92.9589 64.5549 93.1231 73.6758 88.1433 76.8959C83.1635 80.1161 74.9283 76.2155 69.7432 68.1798C64.5581 60.144 64.3821 51.0232 69.3795 47.803Z",
    fill: "url(#paint93_radial_607_7366)"
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M57.8888 66.2795C58.8057 64.0919 60.3466 62.2228 62.3191 60.9053C64.2916 59.5879 66.6084 58.8805 68.9804 58.8713C69.2444 58.8713 69.4966 58.8713 69.7547 58.8713C67.522 59.0284 65.3764 59.8011 63.5562 61.1037C61.736 62.4062 60.3123 64.1876 59.4431 66.2502C58.7903 67.788 58.4551 69.442 58.4577 71.1127C58.4557 72.7833 58.7909 74.4371 59.4431 75.9752C60.3123 78.0378 61.736 79.8192 63.5562 81.1217C65.3764 82.4242 67.522 83.1969 69.7547 83.354C69.4966 83.354 69.2444 83.3833 68.9804 83.3833C66.6084 83.3742 64.2916 82.6668 62.3191 81.3493C60.3466 80.0319 58.8057 78.1628 57.8888 75.9752C57.2319 74.4384 56.8946 72.784 56.8975 71.1127C56.8986 69.4512 57.2358 67.8072 57.8888 66.2795Z",
    fill: "url(#paint94_linear_607_7366)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M81.0339 66.2795C80.1159 64.0914 78.5739 62.2221 76.6004 60.9047C74.6269 59.5873 72.3092 58.8801 69.9363 58.8713C69.6783 58.8713 69.4202 58.8713 69.168 58.8713C71.3999 59.0288 73.5444 59.8018 75.3636 61.1043C77.1828 62.4068 78.6055 64.188 79.4737 66.2502C80.1306 67.787 80.4678 69.4414 80.4649 71.1127C80.4678 72.784 80.1306 74.4384 79.4737 75.9752C78.6055 78.0373 77.1828 79.8185 75.3636 81.121C73.5444 82.4236 71.3999 83.1965 69.168 83.354C69.4202 83.354 69.6783 83.3833 69.9363 83.3833C72.3092 83.3746 74.6269 82.6674 76.6004 81.35C78.5739 80.0326 80.1159 78.1632 81.0339 75.9752C81.6881 74.4376 82.0253 72.7837 82.0252 71.1127C82.0218 69.4515 81.6847 67.8079 81.0339 66.2795Z",
    fill: "url(#paint95_linear_607_7366)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M83.2164 94.0643C71.8901 98.8388 60.8981 98.4282 58.6575 93.1434C56.4169 87.8586 63.7781 79.6938 75.0809 74.9193C86.3838 70.1448 97.3992 70.5553 99.6398 75.846C101.88 81.1367 94.5368 89.2898 83.2164 94.0643Z",
    fill: "url(#paint96_radial_607_7366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M61.0329 95.3664C49.8591 90.2517 42.6445 82.0517 44.9262 77.0543C47.2079 72.0569 58.106 72.1507 69.2798 77.2713C80.4536 82.3919 87.6682 90.5861 85.3865 95.5835C83.1048 100.581 72.2067 100.487 61.0329 95.3664Z",
    fill: "url(#paint97_radial_607_7366)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.589,
    cy: 68.7403,
    rx: 18.6017,
    ry: 18.5277,
    fill: "#FFBC00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_607_7366",
    x1: 47.1686,
    y1: 27.0383,
    x2: 47.1686,
    y2: 121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28293F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28293F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.4278 77.5168) rotate(90) scale(2.14443 38.0636)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3F1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#532F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5E3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#886F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AC9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CABFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E1DBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F2EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3719 57.575) scale(18.1831 18.1831)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_607_7366",
    x1: 43.3194,
    y1: 76.1511,
    x2: 43.3898,
    y2: 71.2475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.8306 60.3277) rotate(90) scale(8.43261 27.5064)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.4082 55.4249) rotate(90) scale(11.4443 25.2978)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.8564 69.9252) rotate(90) scale(4.41708 52.0011)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0156 70.007) rotate(90) scale(4.41708 61.8391)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.4405 29.6573) rotate(89.9011) scale(30.3579 29.2351)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EEEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E7E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D5CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#C5B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5E3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_607_7366",
    x1: 9.72695,
    y1: 32.8538,
    x2: 80.5782,
    y2: 32.1181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFD650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFF8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFFFD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FAB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FFD149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FFD75A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C77219"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_607_7366",
    x1: 43.3316,
    y1: 72.8957,
    x2: 43.1674,
    y2: 0.515273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBEB78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_607_7366",
    x1: 43.29,
    y1: 4.52731,
    x2: 43.1844,
    y2: 61.1823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E7A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E8A838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#EAB043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EEBE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F4D270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FBEB93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.4203 35.7759) rotate(90) scale(6.88658 7.46047)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#3F1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#532F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#7F6464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A69393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#C6BABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#DFD8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F1EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_607_7366",
    x1: 45.5538,
    y1: 40.0254,
    x2: 39.7704,
    y2: 21.8716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFD650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFF8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FAB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FFD149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FFD75A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C77219"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_607_7366",
    x1: 43.8665,
    y1: 29.6865,
    x2: 42.531,
    y2: 36.1483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5630C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_607_7366",
    x1: 43.8639,
    y1: 29.6863,
    x2: 42.5367,
    y2: 36.1482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C4504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE9B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_607_7366",
    x1: 44.5199,
    y1: 26.5343,
    x2: 41.8116,
    y2: 39.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E7A534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E8A838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#EAB043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EEBE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F4D270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FBEB93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.7031 34.5158) rotate(90.8303) scale(2.47715 2.19001)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5321 32.7097) rotate(89.78) scale(1.61889 1.61887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFFFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFFCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFF895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFF384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFEC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FEE45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F2CF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E8BC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DBA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39443"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.4475 34.5118) rotate(90.8303) scale(1.55024 1.37055)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.4629 31.3264) rotate(-3.57634) scale(2.10253 2.00437)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBFB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#EDED62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#D7D759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B9B94C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#91913C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#616128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#282811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.2338 32.7551) rotate(-0.0800004) scale(1.09685 1.09685)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFFFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFFCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFF895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFEC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFE65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FBDE5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EFC854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#DCA548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39443"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3794 32.0703) rotate(-6.70981) scale(1.69477 1.6456)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.4741 11.2429) rotate(46.7716) scale(2.46333 2.18346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.6424 11.7943) rotate(45.8071) scale(1.62566)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFFFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFFCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFF895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFF384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFEC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FEE45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F2CF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E8BC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DBA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39443"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.7711 10.8922) rotate(46.7715) scale(1.54159 1.36645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.7053 62.3682) rotate(-25.8211) scale(2.47246 2.07116)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0757 0.164786) scale(2.47689 2.04612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.1203 1.5007) scale(1.61888 1.61888)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFFFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFFCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFF895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFF384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFEC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FEE45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F2CF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E8BC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DBA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39443"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0231 -0.147919) scale(1.55008 1.37036)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.1924 9.26379) rotate(-44.4093) scale(2.46228 2.05617)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.6443 13.8588) rotate(134.193) scale(1.62567)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFFFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFFCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFF895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFF384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFEC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FEE45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F2CF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E8BC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DBA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39443"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.6687 9.2362) rotate(-44.4095) scale(1.54093 1.36604)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8581 34.4208) rotate(-88.3397) scale(2.47793 2.04631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8807 33.7082) rotate(90) scale(1.61888 1.61889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFFFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFFCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFF895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFF384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFEC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FEE45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F2CF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E8BC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DBA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39443"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2215 34.7092) rotate(-88.3397) scale(1.55073 1.37044)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9577 44.5175) rotate(-109.486) scale(2.47506 2.05491)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9576 44.5175) rotate(-109.486) scale(2.07873 1.72586)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.98 44.72) rotate(64.4626) scale(1.61474)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFFFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFFCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFF895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFF384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFEC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FEE45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F2CF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E8BC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DBA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39443"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.0622 43.0383) rotate(-109.486) scale(1.54894 1.37821)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.8259 54.6577) rotate(-131.424) scale(2.44152 2.05993)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7416 53.3408) rotate(44.5936) scale(1.6141)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFFFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFFCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFF895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFF384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFEC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FEE45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F2CF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E8BC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DBA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39443"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3126 56.9381) rotate(-131.424) scale(1.52795 1.38427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.1067 61.7522) rotate(159.02) scale(1.61888 1.61887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFFFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFFCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFF895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFF384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFEC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FEE45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F2CF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E8BC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DBA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39443"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.6577 47.9112) rotate(-68.6631) scale(2.46646 2.19322)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.3575 43.8254) rotate(-71.301) scale(2.06887 1.71608)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.1178 45.1091) rotate(115.3) scale(1.61888 1.61888)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFFFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFFCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFF895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFF384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFEC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FEE45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F2CF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E8BC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DBA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39443"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.2392 48.049) rotate(-68.663) scale(1.54355 1.37256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.3855 52.8265) rotate(-40.8724) scale(2.46855 2.18823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.5946 53.1317) rotate(135.406) scale(1.6141)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFFFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFFCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFF895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFF384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFEC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FEE45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F2CF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E8BC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DBA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39443"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.647 53.2007) rotate(-40.8723) scale(1.54486 1.36943)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.3677 64.0071) rotate(-25.821) scale(1.54731 1.36661)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.4199 61.4812) rotate(-153.061) scale(2.45625 2.05492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.4366 62.8981) rotate(-156.801) scale(2.06645 1.74184)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1924 60.1773) rotate(21.1612) scale(1.61442 1.61442)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFFFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFFCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFF895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFF384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFEC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FEE45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F2CF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E8BC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DBA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39443"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1888 63.9597) rotate(-153.06) scale(1.53716 1.38647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.2192 6.75306) rotate(-23.1985) scale(2.46045 2.0598)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.8694 5.9522) rotate(-22.1094) scale(2.08266 1.73002)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.5725 3.85349) rotate(160.656) scale(1.61279 1.6128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFFFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFFCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFF895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFF384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFEC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FEE45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F2CF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E8BC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DBA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39443"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.0888 4.7428) rotate(-23.1986) scale(1.53978 1.3687)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.6249 23.1415) rotate(-66.0375) scale(2.4748 2.04108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.973 20.8964) rotate(-66.8014) scale(2.06645 1.72996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3127 21.6917) rotate(109.885) scale(1.61824 1.61823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFFFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFFCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFF895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFF384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFEC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FEE45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F2CF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E8BC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DBA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39443"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0063 21.8417) rotate(-66.0374) scale(1.54877 1.3777)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.3294 24.4774) rotate(68.6631) scale(2.46646 2.20628)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.8809 21.6368) rotate(-111.337) scale(2.07151 1.71872)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.9147 20.2971) rotate(70.1148) scale(1.61823 1.61824)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFFFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFFCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFF895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFF384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFEC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FEE45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F2CF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E8BC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DBA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39443"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.9141 24.3285) rotate(68.6632) scale(1.54356 1.38073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.5566 8.40508) rotate(20.5561) scale(2.45362 2.0671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.8031 7.45402) rotate(-154.933) scale(2.06359 1.72663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.2523 3.8169) rotate(19.2502) scale(1.61887 1.61889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFFFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFFCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFF895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFF384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFEC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FEE45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F2CF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E8BC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DBA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39443"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.6944 2.87878) rotate(20.556) scale(1.53553 1.3725)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.9301 66.7653) rotate(0.114363) scale(32.5012 1.16771)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.4956 66.4284) rotate(-106.113) scale(6.05805 3.13855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#401818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#795D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#A99797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#CEC4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#E9E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F9F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.4533 64.1193) rotate(104.036) scale(6.04362 3.15773)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#401818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#795D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#A99797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#CEC4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#E9E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F9F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_607_7366",
    x1: 43.2375,
    y1: 69.0538,
    x2: 43.2375,
    y2: 51.4573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AE0305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E51E05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D41605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_607_7366",
    x1: 42.8914,
    y1: 68.872,
    x2: 44.0762,
    y2: 56.1849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E50305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D40305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80305"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.2805 83.84) rotate(90) scale(1.54944 11.4271)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3F1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#532F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5E3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#886F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AC9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CABFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E1DBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F2EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.3873 58.3903) rotate(-28.4548) scale(21.6122 17.2781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#230000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#110000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.9979 64.1985) rotate(-120.71) scale(23.6094 8.62438)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#897878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#230000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#110000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_607_7366",
    x1: 91.5161,
    y1: 61.8451,
    x2: 91.9032,
    y2: 78.9196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.0876 63.7883) rotate(-28.7571) scale(9.27196 6.96166)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#171D1C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.1103 62.3077) rotate(-22.3801) scale(4.38893 2.89046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#242A2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.0323 79.0909) rotate(72.2996) scale(8.69003 27.4661)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#360606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#451818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#502626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#7E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#AB9797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#CFC4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#E9E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F9F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.0156 80.9876) rotate(114.944) scale(8.35326 18.6008)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#360606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#451818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#502626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#7E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#AB9797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#CFC4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#E9E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F9F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.7083 72.1001) rotate(160.427) scale(8.41247 18.6616)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#360606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#451818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#502626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#7E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#AB9797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#CFC4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#E9E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F9F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.1788 74.1802) rotate(156.161) scale(8.10679 19.7681)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B94600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#BB4706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C24A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#CE4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#DA5555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE6969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EA9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FCF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_607_7366",
    x1: 80.5604,
    y1: 74.4116,
    x2: 84.7807,
    y2: 71.4562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#319D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#69B7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#A9D6D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D7ECEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F4FAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_607_7366",
    x1: 80.4929,
    y1: 74.3121,
    x2: 84.7074,
    y2: 71.3558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#319D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#69B7AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#A9D6D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D7ECEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F4FAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.9257 89.126) rotate(90) scale(1.99074 12.1436)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#111D06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#222D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3E4735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#404938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#475040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#787E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#A1A69D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C3C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#DDDFDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F0F1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.1305 66.9422) rotate(-49.4795) scale(22.8131 16.929)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF6DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#230000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#110000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.2099 64.2952) rotate(-35.6045) scale(11.5701 7.31741)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#121938"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.3695 66.0644) rotate(-45.807) scale(5.64271 3.45702)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#121938"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.778 62.4041) rotate(-122.807) scale(17.3104 10.7395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#54524A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_607_7366",
    x1: 63.6545,
    y1: 62.5607,
    x2: 63.2792,
    y2: 79.1602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_607_7366",
    x1: 75.2681,
    y1: 62.5607,
    x2: 75.6376,
    y2: 79.1602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.3613 87.141) rotate(66.5014) scale(10.4269 22.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#38551B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#49602D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#65724A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#797F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8A8F74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#BCBFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E0E2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F7F7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_607_7366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.3225 85.6678) rotate(114.444) scale(10.047 22.2272)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#38551B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#49602D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#65724A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#797F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8A8F74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#BCBFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E0E2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F7F7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticImage1);
export default __webpack_public_path__ + "static/media/staticImage1.746c2275bf1b0f6a3dfff1117c125545.svg";
export { ForwardRef as ReactComponent };